import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormGroup, InputGroup, FormControl, SplitButton, MenuItem, DropdownButton, Button } from "react-bootstrap";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import request from "superagent";
import { copy } from "../../utils/clipboard";
import { getClipboardValueForMediaResource } from "../../utils/mediaResourceClipboard";
import autoBind from "react-autobind";
import _ from "lodash";

import {
	isDriveReference,
	getDriveObject,
	getDriveObjectsAsMap,
	listDriveMap,
	getUrlForResource,
	getUrlForValue,
	getResourceReference,
	uploadAndOptimizeMediaFile,
	processExistingDriveVideoFile,
	setActiveTreeCursor,
	uploadFile,
	getDriveObjectByPath,
	listDriveForSelectedFolderSilently,
	setActiveTreeCursorForDriveGuid,
	getFullObjectPath/*, getContent*/
} from "../../actions/drive";
import { showSuccess, showConfirm, showInfoToast, showSaveActivityError } from "../../actions/alertActions";
import InlineFilePicker from "../drive/inlineFilePicker";
import { addExternalResource, injectExternalResourceReference, getDriveObjectForReference, getDriveRootPath, isMediaOptimizationDisabled, setUploadingProps } from "../../actions/activityActions";
import { handleChangeProperty, getSelectedNodePath, handleShowGenerateTtsAudioForPropertyModal, saveChecklist, saveUndoState, showEditorSpinner, showMediaPreviewModal } from "../../actions/actions";
import { refreshCredentials, urlToSecureParameterObject } from "../../utils/securityUtil";
import { isMobile, isAiAssistantEnabled, /*, fixFileNameForS3*/ } from "../../utils/utils";
import { showError } from "../../actions/alertActions";
import { AmbifiLoader } from ".";
import { generateUUID, generatePastedImageFileName } from "../../utils/utils";
import { fixIftttStructureIds } from "../../actions/logicEditorActions";
import PasteImageModal from "./pasteImageModal";
import AiImageGeneratorModal from "./aiImageGeneratorModal";
import MarkupImageModal from "../markupImage/MarkupImageModal";
import MarkupImageModalV2 from "../markupImage/MarkupImageModalV2";
import VideoThumbnailModal from "./videoThumbnailModal";
import VideoChunkModal from "./videoChunkModal";
import ImageEditorModal from "./imageEditorModal";
import DriveMetadataEditorModal from "./driveMetadataEditorModal";
import VideoProcessingAdvancedToggle from "./videoProcessingAdvancedToggle";
import VideoProcessingOptionsModal from "./videoProcessingOptionsModal";
import { launchAiAssistant } from "../../ai/assistantLaunch";
import state from "../../state/state";
import env from "../../constants/env";
import { getOrgId } from "../../actions/orgsActions";
import { getJwtToken } from "../../actions/user";
import {
	getAudioTranscriptionsLambda,
	getAwsTranscribeLambda,
	getImageDescriptionsLambda,
	getPdfResponsesLambda,
	getRekognitionTagsLambda,
	getResponsesCreateLambda
} from "../../ai/aiAssistant";
import { getMediaType } from "../../utils/mediaUtils";
import { isImageToolsEnabledForUrlParams, isMediaToolsEnabledForUrlParams } from "../../utils/mediaTools";
import {
	getDefaultVideoOrientationSummary,
	buildEditedVideoOutputFileName,
	getVideoAudioProcessingLabel,
	getStoredVideoProcessingOptions,
	isVideoAdvancedOptionsEnabled,
	setStoredVideoProcessingOptions,
	setVideoAdvancedOptionsEnabled,
	summarizeVideoFileOrientations,
	shouldPromptForVideoProcessing,
	isVideoFileCandidate,
	buildThumbnailArtifactPath,
	VIDEO_FRAMING_PRESET_OPTIONS,
	VIDEO_ROTATION_PRESET_OPTIONS,
	VIDEO_RESIZE_PRESET_OPTIONS,
	VIDEO_STYLE_FILTER_PRESET_OPTIONS,
	VIDEO_TONE_MAP_PRESET_OPTIONS
} from "../../utils/videoProcessingOptions";
import { getSignedDriveResourceUrl } from "../../persistence/s3";
import { addCategoryNode, addSectionEntity } from "../../utils/entityUtils";
import { getVideoProcessingStatusFeedback } from "../../utils/videoProcessingFeedback";

import ImageWithMarkup from "./imageWithMarkup";

const MAX_METADATA_TITLE_CHARS = 120;
const MAX_METADATA_DESCRIPTION_CHARS = 600;
const MAX_METADATA_TRANSCRIPT_CHARS = 20000;
const MAX_METADATA_TRANSCRIPT_VTT_CHARS = 250000;
const CHUNK_MASTER_VIDEO_SECTION_LABEL = "Master Video";
const TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE = "aws-transcribe";
const TAGS_PROVIDER_OPENAI = "openai";
const TAGS_PROVIDER_REKOGNITION = "rekognition";
const MEDIA_MARKUP_MODAL_VERSION_V2 = "v2";
const MEDIA_MARKUP_MODAL_VERSION_LEGACY = "legacy";

class MediaPropertyInjector extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
				loading: false,
				previewUrl: null,
				mobile: isMobile(),
				uploading: false,
				showAdvancedVideoOptions: isVideoAdvancedOptionsEnabled(),
				showPasteImageModal: false,
				showAiImageGeneratorModal: false,
				showMarkupImageModal: false,
				markupImageModalVersion: MEDIA_MARKUP_MODAL_VERSION_V2,
				showImageEditorModal: false,
				imageEditorTargetPropName: null,
				showVideoThumbnailModal: false,
				videoThumbnailTargetPropName: null,
				showVideoEditorModal: false,
				showVideoChunkModal: false,
				showMediaMetadataPanel: false,
			showPreviewMetadataTitle: true,
			showPreviewMetadataDescription: false,
			showPreviewMetadataTags: false,
			showMetadataEditorModal: false,
			metadataEditorSaving: false,
			metadataEditorTarget: null,
			metadataEditorGalleryItems: [],
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
				metadataEditorPrimaryTags: [],
				metadataEditorSecondaryTags: [],
				metadataEditorTagsInput: "",
				metadataGeneratingField: "",
				metadataTranscriptProvider: TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE,
				metadataTagsProvider: TAGS_PROVIDER_OPENAI,
				showVideoProcessingOptionsModal: false,
				pendingVideoUpload: null,
				processingUpload: null,
				processingStatusNow: Date.now(),
				videoPreviewResolvedUrl: "",
				videoPreviewResolvedGuid: "",
				videoPreviewResolvedRevision: 0,
				videoPreviewResolvedExpiresAt: 0
			};
		this.fileUploadField = React.createRef();
		this.videoProcessingPollTimeout = null;
		this.videoProcessingPollInFlight = false;
		this.videoProcessingElapsedInterval = null;
		this.videoPreviewResolveInFlightKey = "";
		autoBind(this);
	}

	componentDidMount() {
		if (this.getCurrentProcessingUpload()) {
			this.scheduleVideoProcessingPoll();
			this.startVideoProcessingElapsedTimer();
		}
		this.ensureCurrentVideoPreviewResolvedUrl();
	}

	componentDidUpdate(prevProps) {
		const currentProcessingUpload = this.getCurrentProcessingUpload();
		const previousProcessingUpload = this.getCurrentProcessingUpload(prevProps);
		const currentGuid = _.get(currentProcessingUpload, "guid", "");
		const previousGuid = _.get(previousProcessingUpload, "guid", "");

		if (currentGuid && (!previousGuid || currentGuid !== previousGuid)) {
			this.scheduleVideoProcessingPoll();
			this.startVideoProcessingElapsedTimer();
		} else if (currentProcessingUpload && !this.videoProcessingPollTimeout && !this.videoProcessingPollInFlight) {
			this.scheduleVideoProcessingPoll();
			this.startVideoProcessingElapsedTimer();
		} else if (!currentProcessingUpload && previousProcessingUpload) {
			this.stopVideoProcessingPoll();
			this.stopVideoProcessingElapsedTimer();
		} else if (currentProcessingUpload) {
			this.startVideoProcessingElapsedTimer();
		}

		const currentVideoPreviewSignature = this.getCurrentVideoPreviewSignature();
		const previousVideoPreviewSignature = this.getCurrentVideoPreviewSignature(prevProps);
		if (currentVideoPreviewSignature !== previousVideoPreviewSignature) {
			this.ensureCurrentVideoPreviewResolvedUrl(true);
		} else {
			this.ensureCurrentVideoPreviewResolvedUrl();
		}
	}

	componentWillUnmount() {
		this.stopVideoProcessingPoll();
		this.stopVideoProcessingElapsedTimer();
	}

	handleSwitchMode(mode) {
		if (this.props.onValueChange) {
			if (mode === "drive") {
				this.props.onValueChange(getResourceReference(null));
			} else {
				this.props.onValueChange("https://");
			}
		}
	}

	isAiAssistantUiEnabled() {
		return isAiAssistantEnabled(this.props.urlParams || {}, this.props.selectedOrg);
	}

	isImageToolsEnabled() {
		return isImageToolsEnabledForUrlParams(this.props.urlParams);
	}

	isMediaToolsEnabled() {
		return isMediaToolsEnabledForUrlParams(this.props.urlParams);
	}

	isMediaMarkupV2Enabled() {
		return this.isImageToolsEnabled();
	}

	getMarkupPreviewAudioUrl(entity = null) {
		const audioCandidates = [
			_.get(entity, "label1AudioFile", null),
			_.get(entity, "labelAudioFile", null),
			_.get(entity, "audio", null),
			_.get(entity, "backgroundAudio", null)
		];

		for (let index = 0; index < audioCandidates.length; index += 1) {
			const audioUrl = getUrlForValue(audioCandidates[index]);
			if (_.isString(audioUrl) && audioUrl.trim() !== "") {
				return audioUrl;
			}
		}

		return "";
	}

	handleDeleteMediaProperty() {
		showConfirm("Are you sure you want to delete this media item?", "Delete Media", () => {
			this.props.onValueChange("");
		});
	}

	handleSelectFile(info) {
		console.log(info);
		const { propName } = this.props;
		injectExternalResourceReference(propName, info, getSelectedNodePath(), this.props.onChange);
		this.syncDriveSelectionForAssistant(info);
		this.setState({
			showMediaMetadataPanel: false
		});
	}

	getSelectedNodeEntity() {
		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || !selectedNodePath.length) {
			return null;
		}

		const selectedNode = state.get(selectedNodePath);
		if (!selectedNode || !selectedNode.entity) {
			return null;
		}

		return selectedNode.entity;
	}

	getSelectedNodeHierarchyEntities() {
		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || !selectedNodePath.length) {
			return [];
		}

		const hierarchyEntities = [];
		let cursor = state.select(selectedNodePath);

		while (cursor) {
			const currentValue = cursor.get();
			const currentEntity = _.get(currentValue, "entity", null);
			if (currentEntity && _.isString(currentEntity.type)) {
				hierarchyEntities.push(currentEntity);
			}

			cursor = cursor.up ? cursor.up() : null;
		}

		return hierarchyEntities.reverse();
	}

	getAuthorPropertiesObject(entity = {}) {
		const authorProperties = entity.authorProperties;
		if (_.isPlainObject(authorProperties)) {
			return authorProperties;
		}
		if (!_.isString(authorProperties) || authorProperties.trim() === "") {
			return {};
		}

		try {
			const parsedProperties = JSON.parse(authorProperties);
			return _.isPlainObject(parsedProperties) ? parsedProperties : {};
		} catch (err) {
			return {};
		}
	}

	normalizeCameraEffects(value) {
		if (Array.isArray(value)) {
			return value;
		}
		if (_.isPlainObject(value)) {
			return [value];
		}
		return [];
	}

	getCameraRectSnapshot(rect = null) {
		if (!_.isPlainObject(rect) || !Object.prototype.hasOwnProperty.call(rect, "width") || !Object.prototype.hasOwnProperty.call(rect, "height")) {
			return null;
		}

		const width = Number(rect.width);
		const height = Number(rect.height);
		if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
			return null;
		}

		const snapshot = {
			x: Number.isFinite(Number(rect.x)) ? Number(rect.x) : 0,
			y: Number.isFinite(Number(rect.y)) ? Number(rect.y) : 0,
			width,
			height
		};
		if (Number.isFinite(Number(rect.rotation))) {
			snapshot.rotation = Number(rect.rotation);
		}
		return snapshot;
	}

	getLastCameraEndContextForEntity(entity = {}) {
		const authorProperties = this.getAuthorPropertiesObject(entity);
		const cameraEffects = this.normalizeCameraEffects(authorProperties.imageKenBurnsEffect || entity.imageKenBurnsEffect);
		if (cameraEffects.length === 0) {
			return null;
		}

		for (let index = cameraEffects.length - 1; index >= 0; index -= 1) {
			const effect = cameraEffects[index];
			const cameraStart = this.getCameraRectSnapshot(_.get(effect, "camera.end", null));
			if (!cameraStart) {
				continue;
			}

			const cameraStartVariants = {};
			const variants = authorProperties.imageKenBurnsEffectVariants || entity.imageKenBurnsEffectVariants || {};
			const effectGuid = effect.guid || "";
			if (effectGuid && _.isPlainObject(variants)) {
				Object.keys(variants).forEach((variantKey) => {
					const override = _.get(variants, [variantKey, "cameras", effectGuid], null);
					if (!_.isPlainObject(override)) {
						return;
					}
					const variantCameraStart = this.getCameraRectSnapshot(Object.assign({}, cameraStart, override));
					if (variantCameraStart) {
						cameraStartVariants[variantKey] = variantCameraStart;
					}
				});
			}

			return {
				cameraStart,
				cameraStartVariants,
				sourceCameraGuid: effectGuid,
				sourceCameraId: effect.id || "",
				sourceItemGuid: entity.guid || "",
				sourceItemLabel: entity.label1 || entity.label || entity.name || entity.navTitle || "Previous screen"
			};
		}

		return null;
	}

	collectItemNodesForCameraStart(node = null, path = [], result = []) {
		if (!node) {
			return result;
		}

		const entity = _.get(node, "entity", {});
		const entityType = `${_.get(entity, "type", "")}`.trim();
		if (entityType.startsWith("item")) {
			result.push({
				node,
				entity,
				path
			});
		}

		const children = Array.isArray(node.children) ? node.children : [];
		children.forEach((child, index) => {
			this.collectItemNodesForCameraStart(child, path.concat(["children", index]), result);
		});

		return result;
	}

	getPreviousCameraStartContext() {
		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || selectedNodePath.length === 0) {
			return null;
		}

		const rootNode = state.get(["tree", "root"]);
		if (!rootNode) {
			return null;
		}

		const itemNodes = this.collectItemNodesForCameraStart(rootNode, ["tree", "root"], []);
		const selectedIndex = itemNodes.findIndex((entry) => _.isEqual(entry.path, selectedNodePath));
		if (selectedIndex <= 0) {
			return null;
		}

		for (let index = selectedIndex - 1; index >= 0; index -= 1) {
			const previousContext = this.getLastCameraEndContextForEntity(itemNodes[index].entity);
			if (previousContext) {
				return previousContext;
			}
		}

		return null;
	}

	getEffectiveImageResizeMode() {
		const hierarchyEntities = this.getSelectedNodeHierarchyEntities();
		const hierarchyTypes = new Set(["checklist", "list", "section"]);
		let effectiveResizeMode = "contain";

		for (let index = 0; index < hierarchyEntities.length; index += 1) {
			const entity = hierarchyEntities[index];
			const entityType = `${_.get(entity, "type", "")}`.trim();
			const isSupportedItemType = entityType.startsWith("item");
			if (!hierarchyTypes.has(entityType) && !isSupportedItemType) {
				continue;
			}

			const rawResizeMode = `${_.get(entity, "imageResizeMode", "")}`.trim().toLowerCase();
			if (!rawResizeMode || rawResizeMode === "inherit") {
				continue;
			}

			effectiveResizeMode = rawResizeMode;
		}

		return effectiveResizeMode;
	}

	getAssociatedVideoThumbnailSource() {
		const entity = this.getSelectedNodeEntity();
		if (!entity || !entity.video) {
			return null;
		}

		const videoValue = entity.video;
		const label = entity.label || entity.title || entity.name || "video-thumbnail";
		const defaultBaseName = `${label}-thumbnail`;

		if (_.isString(videoValue)) {
			const rawValue = `${videoValue || ""}`;
			const videoFileName = rawValue.split("?")[0].split("#")[0].split("/").pop() || "";
			return {
				url: videoValue,
				label,
				defaultBaseName,
				videoFileName
			};
		}

		if (!isDriveReference(videoValue)) {
			return null;
		}

		try {
			const resource = getDriveObjectForReference(videoValue);
			if (!resource) {
				return null;
			}

			const drivePath = this.getDriveResourcePath(resource);

			return {
				url: getUrlForResource(resource),
				label: resource.name || label,
				defaultBaseName,
				driveObjectGuid: resource.guid || null,
				videoFileName: resource.name || ((resource.path || "").split("/").pop() || ""),
				drivePath,
				resource
			};
		} catch (err) {
			console.warn(err);
			return null;
		}
	}

	canCreateVideoThumbnail() {
		return !!this.getAssociatedVideoThumbnailSource();
	}

	canEditCurrentVideo() {
		const videoSource = this.getAssociatedVideoThumbnailSource();
		return !!(this.isMediaToolsEnabled() && videoSource && videoSource.drivePath && videoSource.resource);
	}

	canAutoCreateChunkOutline() {
		const entity = this.getSelectedNodeEntity();
		const entityType = `${_.get(entity, "type", "")}`.trim();
		return entityType.startsWith("item") && entityType !== "itemContainer";
	}

	canAutoCreateChunkOutlineSections() {
		if (!this.canAutoCreateChunkOutline()) {
			return false;
		}

		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || selectedNodePath.length === 0) {
			return false;
		}

		const selectedNodeCursor = state.select(selectedNodePath);
		const parentNode = selectedNodeCursor && selectedNodeCursor.up && selectedNodeCursor.up() && selectedNodeCursor.up().up
			? selectedNodeCursor.up().up().get()
			: null;
		const parentEntityType = `${_.get(parentNode, "entity.type", "")}`.trim();
		return parentEntityType === "section" || parentEntityType === "checklist";
	}

	canChunkCurrentVideo() {
		return !!(this.isMediaToolsEnabled() && this.getCurrentVideoChunkSource());
	}

	getCurrentVideoChunkSource() {
		if (!this.canEditCurrentVideo()) {
			return null;
		}

		const videoSource = this.getAssociatedVideoThumbnailSource();
		if (!videoSource || !videoSource.drivePath || !videoSource.resource) {
			return null;
		}

		const resource = videoSource.resource;
		const metaData = resource && resource.metaData && typeof resource.metaData === "object"
			? resource.metaData
			: {};
		const currentDrivePath = `${videoSource.drivePath || ""}`.trim();
		const resourceRole = `${metaData.videoAssetRole || ""}`.trim().toLowerCase();
		const masterDrivePath = resourceRole !== "master"
			? `${metaData.masterVideoDrivePath || ""}`.trim()
			: "";
		const hasMasterSource = !!masterDrivePath;
		const playbackChunkSource = {
			bucket: _.get(env, "s3.assetsBucket", ""),
			key: currentDrivePath
		};
		const masterChunkSource = hasMasterSource ? {
			bucket: _.get(env, "s3.assetsBucket", ""),
			key: masterDrivePath
		} : null;

		return {
			previewUrl: this.getResolvedVideoPreviewUrl(videoSource.url, resource),
			fileName: videoSource.videoFileName || resource.name || "video.mp4",
			chunkSource: playbackChunkSource,
			playbackChunkSource,
			masterChunkSource,
			baseOutputPath: currentDrivePath,
			sourcePlaybackGuid: `${resource.guid || ""}`.trim(),
			sourcePlaybackPath: currentDrivePath,
			baseProcessingOptions: {},
			playbackBaseProcessingOptions: {},
			masterBaseProcessingOptions: hasMasterSource ? _.get(metaData, "videoProcessing", {}) : {},
			sourceMetaData: metaData,
			defaultUseMasterSource: false,
			usingMasterSource: false,
			sourceDescription: resourceRole === "master"
				? "Generated output renders directly from the selected master source."
				: "Generated output renders from the currently selected Drive video.",
			playbackSourceDescription: resourceRole === "master"
				? "Generated output renders directly from the selected master source."
				: "Generated output renders directly from the current playback MP4 for fastest chunking.",
			masterSourceDescription: hasMasterSource
				? "Generated output renders from the preserved master source and reapplies the current playback processing."
				: ""
		};
	}

	getCurrentVideoChunkDraft() {
		const entity = this.getSelectedNodeEntity();
		const savedDraft = entity && entity.chunkVideoDraft && typeof entity.chunkVideoDraft === "object"
			? entity.chunkVideoDraft
			: null;
		return savedDraft ? _.cloneDeep(savedDraft) : null;
	}

	async handleSaveVideoChunkDraft(draftPayload = null) {
		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || !selectedNodePath.length) {
			throw new Error("Unable to save chunk video draft because no activity item is selected.");
		}

		const draftPath = _.concat(selectedNodePath, "entity", "chunkVideoDraft");
		saveUndoState();
		if (draftPayload && typeof draftPayload === "object") {
			state.set(draftPath, _.cloneDeep(draftPayload));
		} else {
			state.unset(draftPath);
		}

		showEditorSpinner();
		await saveChecklist().catch((error) => {
			console.error(error);
			showSaveActivityError(error);
			throw error;
		});
	}

	async handleSaveMediaMarkupActivity() {
		showEditorSpinner();
		await saveChecklist().catch((error) => {
			console.error(error);
			showSaveActivityError(error);
			throw error;
		});
	}

	getCurrentImageEditorSource() {
		const imageValue = this.props.value;
		if (!imageValue) {
			return null;
		}

		const entity = this.getSelectedNodeEntity();
		const label = _.trim(_.get(entity, "label", "") || _.get(entity, "title", "") || _.get(entity, "name", ""));
		const fallbackBaseName = label !== "" ? `${label}-edited` : "image-edited";

		if (_.isString(imageValue)) {
			return {
				url: imageValue,
				label: label || imageValue,
				defaultBaseName: fallbackBaseName,
				resource: null,
				originalImageName: _.last(`${imageValue}`.split("/")) || "image.png",
				overwriteTargetPath: ""
			};
		}

		if (!isDriveReference(imageValue)) {
			return null;
		}

		try {
			const resource = getDriveObjectForReference(imageValue);
			if (!resource) {
				return null;
			}

			const resourcePath = this.getDriveResourcePath(resource);
			const resourceFileName = _.last(`${resourcePath || ""}`.split("/")) || "";
			const resourceName = resource.name || label || "image";
			const resourceStem = `${resourceName}`.replace(/\.[^/.]+$/, "") || "image";

			return {
				url: getUrlForResource(resource),
				label: resourceName,
				defaultBaseName: `${resourceStem}-edited`,
				resource,
				driveObjectGuid: resource.guid || null,
				originalImageName: resourceFileName || resource.name || `${resourceStem}.png`,
				overwriteTargetPath: resourcePath
			};
		} catch (err) {
			console.warn(err);
			return null;
		}
	}

	canEditCurrentImage() {
		return !!this.getCurrentImageEditorSource();
	}

	getDriveResourceFromValue(value = this.props.value) {
		if (!isDriveReference(value)) {
			return null;
		}

		try {
			return getDriveObjectForReference(value);
		} catch (err) {
			console.warn(err);
			return null;
		}
	}

	getDriveResourcePath(resource = null) {
		const target = resource || {};
		if (typeof target.path === "string" && target.path.trim() !== "") {
			return target.path.trim();
		}
		if (Array.isArray(target.path) && target.path.length > 0) {
			return target.path.join("/");
		}
		if (typeof target.fullPath === "string" && target.fullPath.trim() !== "") {
			return target.fullPath.trim();
		}
		return "";
	}

	getCurrentVideoPreviewResource(props = this.props) {
		if (_.get(props, "propName") !== "video") {
			return null;
		}
		return this.getDriveResourceFromValue(_.get(props, "value"));
	}

	getCurrentVideoPreviewSignature(props = this.props) {
		const resource = this.getCurrentVideoPreviewResource(props);
		const guid = `${_.get(resource, "guid", "")}`.trim();
		const revision = Number(_.get(resource, "revision")) || 0;
		const path = `${this.getDriveResourcePath(resource) || ""}`.trim();
		if (!guid) {
			return "";
		}
		return `${guid}:${revision}:${path}`;
	}

	shouldRefreshResolvedVideoPreviewUrl(resource = null, force = false) {
		if (force) {
			return true;
		}

		const target = resource || this.getCurrentVideoPreviewResource();
		const guid = `${_.get(target, "guid", "")}`.trim();
		const revision = Number(_.get(target, "revision")) || 0;
		if (!guid || !revision) {
			return false;
		}

		return !(
			this.state.videoPreviewResolvedUrl &&
			this.state.videoPreviewResolvedGuid === guid &&
			(Number(this.state.videoPreviewResolvedRevision) || 0) === revision &&
			(Number(this.state.videoPreviewResolvedExpiresAt) || 0) > (Date.now() + 30000)
		);
	}

	ensureCurrentVideoPreviewResolvedUrl(force = false, props = this.props) {
		const resource = this.getCurrentVideoPreviewResource(props);
		if (!resource || !resource.guid) {
			return;
		}
		if (!this.shouldRefreshResolvedVideoPreviewUrl(resource, force)) {
			return;
		}

		const guid = `${_.get(resource, "guid", "")}`.trim();
		const revision = Number(_.get(resource, "revision")) || 0;
		const requestKey = `${guid}:${revision}`;
		if (this.videoPreviewResolveInFlightKey === requestKey) {
			return;
		}

		this.videoPreviewResolveInFlightKey = requestKey;
		this.refreshVideoPreviewResolvedUrlForResource(resource).catch((error) => {
			console.warn("Unable to resolve signed preview URL for current video", error);
		}).finally(() => {
			if (this.videoPreviewResolveInFlightKey === requestKey) {
				this.videoPreviewResolveInFlightKey = "";
			}
		});
	}

	resolveDriveSelectionResource(resource = null) {
		const target = resource || this.getDriveResourceFromValue();
		if (!target || target.type === "folder") {
			return null;
		}
		if (target.guid) {
			return target;
		}

		const targetPath = this.getDriveResourcePath(target);
		if (!targetPath) {
			return target;
		}

		const lookedUp = getDriveObjectByPath(targetPath, this.props.propName === "video");
		if (lookedUp && lookedUp.type !== "folder") {
			return {
				...target,
				...lookedUp
			};
		}

		return target;
	}

	syncDriveSelectionForAssistant(resource = null) {
		const nextResource = this.resolveDriveSelectionResource(resource);
		if (!nextResource) {
			return;
		}

		setActiveTreeCursor(nextResource);
	}

	handleUseInAiAssistant(resource = null, prefillQuestion = "") {
		if (!this.isAiAssistantUiEnabled()) {
			showError("AI Assistant", "Enable AI Assistant with ?aiAssistant=true or ?futureAi=true.");
			return;
		}

		const nextResource = this.resolveDriveSelectionResource(resource);
		if (!nextResource) {
			showError("AI Assistant", "Select a Drive file first.");
			return;
		}

		this.syncDriveSelectionForAssistant(nextResource);
		const launchRequest = launchAiAssistant({
			mode: "drive_asset",
			preferredPanelMode: "side",
			prefillQuestion
		});
		// Fallback if centralized launch helper is feature-gated in this environment.
		if (!launchRequest) {
			state.set(["appState", "aiAssistantLaunchRequest"], {
				requestId: `${Date.now()}-drive-asset-launch`,
				mode: "drive_asset",
				prefillQuestion,
				preferredPanelMode: "side",
				targetPath: null,
				targetLabel: "",
				targetFieldType: "",
				responseFormat: "",
				targetReadOnly: false,
				featureName: "",
				featureDescription: "",
				additionalContextLines: [],
				autoRun: false
			});
		}
		setTimeout(() => {
			this.scrollAssistantIntoView();
		}, 120);
	}

	scrollAssistantIntoView() {
		if (typeof document === "undefined") {
			return;
		}
		const assistantRoot =
			document.getElementById("app-ai-assistant-root") ||
			document.querySelector("[data-ai-assistant-root='true']");
		if (assistantRoot && typeof assistantRoot.scrollIntoView === "function") {
			assistantRoot.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			});
		}
	}

	buildMetadataEditorStateForResource(resource) {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object"
			? resource.metaData
			: {};
		const primaryTags = this.mergeUniqueMetadataTags(this.normalizeMetadataTagSource(metaData.tags));
		const secondaryTags = this.mergeUniqueMetadataTags([
			...this.normalizeMetadataTagSource(metaData.rekognitionTags),
			...this.normalizeMetadataTagSource(metaData.openAiTags),
			...this.normalizeMetadataTagSource(metaData.labels),
			...this.normalizeMetadataTagSource(resource?.labels)
		]).filter((tag) => !primaryTags.map((entry) => entry.toLowerCase()).includes(tag.toLowerCase()));

		return {
			metadataEditorTitle: this.cleanMetadataTitle(metaData.title || ""),
			metadataEditorDescription: this.cleanMetadataDescription(metaData.description || ""),
			metadataEditorTranscript: this.cleanMetadataTranscript(metaData.transcript || ""),
			metadataEditorTranscriptVtt: this.cleanMetadataTranscriptVtt(metaData.transcriptVtt || ""),
			metadataEditorPrimaryTags: primaryTags,
			metadataEditorSecondaryTags: secondaryTags,
			metadataEditorTagsInput: "",
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		};
	}

	handleShowMetadataEditor(resource = null) {
		const nextResource = this.resolveDriveSelectionResource(resource);
		if (!nextResource) {
			showError("Metadata", "Select a Drive file first.");
			return;
		}

		const metadataEditorGalleryItems = this.state.showMetadataEditorModal && Array.isArray(this.state.metadataEditorGalleryItems) && this.state.metadataEditorGalleryItems.length > 0
			? this.state.metadataEditorGalleryItems
			: this.buildMetadataEditorGalleryItemsForResource(nextResource);

		this.setState({
			showMetadataEditorModal: true,
			metadataEditorSaving: false,
			metadataEditorTarget: nextResource,
			metadataEditorGalleryItems,
			...this.buildMetadataEditorStateForResource(nextResource)
		});
	}

	buildMetadataEditorGalleryItemsForResource(targetResource = this.state.metadataEditorTarget) {
		const target = this.resolveDriveSelectionResource(targetResource);
		if (!target || this.getMetadataResourceMediaType(target) !== "image") {
			return [];
		}

		const targetPath = this.getDriveResourcePath(target);
		const targetFolderPath = targetPath ? targetPath.split("/").slice(0, -1).join("/") : "";
		if (!targetFolderPath) {
			return [];
		}

		const resources = Object.values(getDriveObjectsAsMap() || {})
			.filter((resource) => {
				if (!resource || resource.type !== "file" || this.getMetadataResourceMediaType(resource) !== "image") {
					return false;
				}
				const resourcePath = this.getDriveResourcePath(resource);
				return resourcePath && resourcePath.split("/").slice(0, -1).join("/") === targetFolderPath;
			});
		const hasTarget = resources.some((resource) => {
			const resourceKey = resource.guid || this.getDriveResourcePath(resource) || resource.name;
			const targetKey = target.guid || targetPath || target.name;
			return resourceKey === targetKey;
		});
		const galleryResources = hasTarget ? resources : [...resources, target];

		return _.sortBy(galleryResources, (resource) => (resource.name || this.getDriveResourcePath(resource) || "").toLowerCase())
			.map((resource) => ({
				key: resource.guid || this.getDriveResourcePath(resource) || resource.name,
				name: resource.name || this.getDriveResourcePath(resource) || "image",
				url: getUrlForResource(resource, resource),
				type: "image",
				resource
			}));
	}

	getMetadataEditorGalleryItems() {
		if (this.state.showMetadataEditorModal && Array.isArray(this.state.metadataEditorGalleryItems) && this.state.metadataEditorGalleryItems.length > 0) {
			return this.state.metadataEditorGalleryItems;
		}

		return this.buildMetadataEditorGalleryItemsForResource(this.state.metadataEditorTarget);
	}

	getMetadataEditorGalleryIndex(galleryItems = this.getMetadataEditorGalleryItems()) {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target || !Array.isArray(galleryItems) || galleryItems.length === 0) {
			return -1;
		}
		const targetKey = target.guid || this.getDriveResourcePath(target) || target.name;
		return galleryItems.findIndex((item) => {
			const resource = item.resource || item;
			return (resource.guid || this.getDriveResourcePath(resource) || resource.name) === targetKey;
		});
	}

	handleMetadataEditorGallerySelect(item) {
		const resource = item && (item.resource || item);
		if (!resource || resource.type !== "file") {
			return;
		}
		this.handleShowMetadataEditor(resource);
	}

	async handleSaveMetadataEditorAndNavigate(offset = 1) {
		const galleryItems = this.getMetadataEditorGalleryItems();
		const currentIndex = this.getMetadataEditorGalleryIndex(galleryItems);
		if (galleryItems.length === 0 || currentIndex < 0) {
			await this.handleSaveMetadataEditor();
			return;
		}
		const nextIndex = (currentIndex + offset + galleryItems.length) % galleryItems.length;
		const savedResource = await this.handleSaveMetadataEditor({ closeModal: false, showSuccess: false });
		if (savedResource) {
			this.handleMetadataEditorGallerySelect(galleryItems[nextIndex]);
		}
	}

	handleHideMetadataEditor() {
		this.setState({
			showMetadataEditorModal: false,
			metadataEditorSaving: false,
			metadataEditorTarget: null,
			metadataEditorGalleryItems: [],
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataEditorPrimaryTags: [],
			metadataEditorSecondaryTags: [],
			metadataEditorTagsInput: "",
			metadataGeneratingField: "",
			metadataTranscriptProvider: TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE,
			metadataTagsProvider: TAGS_PROVIDER_OPENAI
		});
	}

	handleMetadataEditorTitleChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTitle: rawValue.slice(0, MAX_METADATA_TITLE_CHARS)
		});
	}

	handleMetadataEditorDescriptionChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorDescription: rawValue.slice(0, MAX_METADATA_DESCRIPTION_CHARS)
		});
	}

	handleMetadataEditorTranscriptChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscript: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_CHARS)
		});
	}

	handleMetadataEditorTranscriptVttChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscriptVtt: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS)
		});
	}

	handleMetadataEditorTagsInputChange(event) {
		this.setState({
			metadataEditorTagsInput: event?.target?.value || ""
		});
	}

	handleAddMetadataEditorInputTags() {
		const inputTags = this.normalizeMetadataTagSource(this.state.metadataEditorTagsInput);
		if (!inputTags.length) {
			return;
		}
		this.setState((prev) => ({
			metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([
				...(prev.metadataEditorPrimaryTags || []),
				...inputTags
			]),
			metadataEditorTagsInput: ""
		}));
	}

	handleRemoveMetadataEditorPrimaryTag(tagToRemove) {
		this.setState((prev) => ({
			metadataEditorPrimaryTags: (prev.metadataEditorPrimaryTags || []).filter((tag) => {
				return `${tag}`.toLowerCase() !== `${tagToRemove}`.toLowerCase();
			})
		}));
	}

	handlePromoteMetadataEditorSecondaryTag(tagToPromote) {
		this.setState((prev) => ({
			metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([
				...(prev.metadataEditorPrimaryTags || []),
				tagToPromote
			]),
			metadataEditorSecondaryTags: (prev.metadataEditorSecondaryTags || []).filter((tag) => {
				return `${tag}`.toLowerCase() !== `${tagToPromote}`.toLowerCase();
			})
		}));
	}

	handlePromoteAllMetadataEditorSecondaryTags() {
		this.setState((prev) => ({
			metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([
				...(prev.metadataEditorPrimaryTags || []),
				...(prev.metadataEditorSecondaryTags || [])
			]),
			metadataEditorSecondaryTags: []
		}));
	}

	handleMetadataTranscriptProviderChange(event) {
		this.setState({ metadataTranscriptProvider: event?.target?.value || TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE });
	}

	handleMetadataTagsProviderChange(event) {
		this.setState({ metadataTagsProvider: event?.target?.value || TAGS_PROVIDER_OPENAI });
	}

	async handleGenerateMetadataTitle() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target) {
			showError("Metadata", "Select a file before generating a title.");
			return;
		}

		this.setState({ metadataGeneratingField: "title" });
		try {
			const prompt = [
				"You are generating metadata for a Drive asset.",
				"Return only a concise title (no label, no quotes, no markdown), max 120 characters.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const title = this.cleanMetadataTitle(responseText);
			if (!title) {
				throw new Error("Generation returned an empty title.");
			}
			this.setState({ metadataEditorTitle: title });
		} catch (err) {
			showError("Generate Title", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataDescription() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target) {
			showError("Metadata", "Select a file before generating a description.");
			return;
		}

		this.setState({ metadataGeneratingField: "description" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			let responseText = "";

			if (mediaType === "image") {
				const s3Key = this.getMetadataResourceS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected image.");
				}
				const imageContextHints = this.buildMetadataImageContextHints();
				responseText = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: [
						"Describe this specific image in one concise searchable description for asset metadata.",
						"Use the image itself as the primary evidence.",
						"Use file name and Drive path only as secondary context when they provide useful identifiers such as community, model, room, or lot ID.",
						"Do not invent details that are not visible in the image or clearly supported by the path context.",
						"Return only the description, max 600 characters.",
						"",
						imageContextHints
					].filter(Boolean).join("\n")
				}));
			} else {
				const prompt = [
					"You are generating metadata for a Drive asset.",
					"Return only one concise description for search/discovery, max 600 characters.",
					"No markdown, no headings, no source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				responseText = await this.runMetadataResponsesPrompt(prompt);
			}

			const description = this.cleanMetadataDescription(responseText);
			if (!description) {
				throw new Error("Generation returned an empty description.");
			}
			this.setState({ metadataEditorDescription: description });
		} catch (err) {
			showError("Generate Description", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscript() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const { metadataTranscriptProvider } = this.state;
		if (!target) {
			showError("Metadata", "Select a file before generating transcript/content text.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcript" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			const s3Key = this.getMetadataResourceS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				if (mediaType !== "audio" && mediaType !== "video") {
					throw new Error("AWS Transcribe generation is only supported for audio/video files.");
				}
				const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					response_format: "text"
				}), { showAlert: false });
				let transcriptText = this.cleanMetadataTranscript(this.extractAwsTranscribeText(awsResponse));
				const transcriptVtt = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
				if (!transcriptText && transcriptVtt) {
					transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
				}
				if (!transcriptText) {
					throw new Error("AWS Transcribe returned empty transcript.");
				}
				this.setState({
					metadataEditorTranscript: transcriptText,
					...(transcriptVtt ? { metadataEditorTranscriptVtt: transcriptVtt } : {})
				});
				return;
			}

			let transcriptText = "";
			if (mediaType === "audio" || mediaType === "video") {
				const response = await getAudioTranscriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: `Transcribe this ${mediaType} into plain text with useful section breaks.`
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "image") {
				const response = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: "Describe this image in plain text for accessibility and search."
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "pdf") {
				const response = await getPdfResponsesLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					model: "gpt-5.4",
					prompt: "Summarize this selected PDF into clean, practical sections for searchable content metadata."
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else {
				const prompt = [
					"You are generating a long-form content text field for a Drive asset.",
					"For non-audio/video files, produce a concise content representation based on available metadata.",
					"No markdown tables. No source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				transcriptText = await this.runMetadataResponsesPrompt(prompt);
			}

			const cleanedTranscript = this.cleanMetadataTranscript(transcriptText);
			if (!cleanedTranscript) {
				throw new Error("Generation returned empty transcript/content text.");
			}
			this.setState({ metadataEditorTranscript: cleanedTranscript });
		} catch (err) {
			showError("Generate Transcript", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscriptVtt() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const { metadataTranscriptProvider } = this.state;
		if (!target) {
			showError("Generate VTT", "Select a file before generating timed transcript.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcriptVtt" });
		try {
			const mediaType = this.getMetadataResourceMediaType(target);
			if (mediaType !== "audio" && mediaType !== "video") {
				throw new Error("Timed transcript (VTT) is currently only supported for audio/video files.");
			}

			const s3Key = this.getMetadataResourceS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					response_format: "vtt"
				}), { showAlert: false });
				let vttText = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
				if (!vttText) {
					vttText = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeText(awsResponse));
				}
				if (!vttText || !/-->/m.test(vttText)) {
					throw new Error("AWS Transcribe did not return valid VTT timestamp cues.");
				}
				this.setState({ metadataEditorTranscriptVtt: vttText });
				return;
			}

			const response = await getAudioTranscriptionsLambda(JSON.stringify({
				bucket: env.s3.assetsBucket,
				key: s3Key,
				fileName: target.name || "",
				mediaType,
				model: "whisper-1",
				response_format: "vtt"
			}), { showAlert: false });

			const rawVtt = this.extractResponsesText(response);
			if (!/-->/m.test(`${rawVtt || ""}`)) {
				throw new Error("VTT output did not include timestamp cues.");
			}
			const cleanedVtt = this.cleanMetadataTranscriptVtt(rawVtt);
			if (!cleanedVtt) {
				throw new Error("Generation returned empty VTT content.");
			}
			this.setState({ metadataEditorTranscriptVtt: cleanedVtt });
		} catch (err) {
			showError("Generate VTT", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTags() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const { metadataTagsProvider } = this.state;
		if (!target) {
			showError("Metadata", "Select a file before generating tags.");
			return;
		}

		this.setState({ metadataGeneratingField: "tags" });
		try {
			if (metadataTagsProvider === TAGS_PROVIDER_REKOGNITION) {
				const s3Key = this.getMetadataResourceS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}
				const rekognitionResponse = await getRekognitionTagsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					maxLabels: 25,
					minConfidence: 70
				}), { showAlert: false });
				const generatedTags = this.extractTagsFromRekognitionPayload(rekognitionResponse);
				if (!generatedTags.length) {
					throw new Error("No Rekognition tags generated.");
				}
				this.setState((prev) => ({
					metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([...(prev.metadataEditorPrimaryTags || []), ...generatedTags])
				}));
				return;
			}

			const mediaType = this.getMetadataResourceMediaType(target);
			let responseText = "";

			if (mediaType === "image") {
				const s3Key = this.getMetadataResourceS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected image.");
				}
				const imageContextHints = this.buildMetadataImageContextHints();
				responseText = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: [
						"Generate searchable tags for this specific image asset.",
						"Use the image itself as the primary evidence.",
						"Use file name and Drive path only as secondary context when they provide useful identifiers such as community, model, room, or lot ID.",
						"Do not invent details that are not visible in the image or clearly supported by the path context.",
						"Return only one comma-separated line of short tags. No bullets, no explanations, max 15 tags.",
						"",
						imageContextHints
					].filter(Boolean).join("\n")
				}));
			} else {
				const prompt = [
					"You are generating searchable tags for a Drive asset.",
					"Return only one comma-separated line of tags (no bullets, no explanations).",
					"Use short phrases. Max 15 tags.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				responseText = await this.runMetadataResponsesPrompt(prompt);
			}

			const generatedTags = this.parseGeneratedTags(responseText);
			if (!generatedTags.length) {
				throw new Error("Generation returned no tags.");
			}
			this.setState((prev) => ({
				metadataEditorPrimaryTags: this.mergeUniqueMetadataTags([...(prev.metadataEditorPrimaryTags || []), ...generatedTags])
			}));
		} catch (err) {
			showError("Generate Tags", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleSaveMetadataEditor(options = {}) {
		const closeModal = options.closeModal !== false;
		const showSavedMessage = options.showSuccess !== false;
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		if (!target) {
			showError("Metadata", "Select a Drive file first.");
			return null;
		}

		const path = this.getDriveResourcePath(target);
		if (!path) {
			showError("Metadata", "Unable to save metadata because file path is missing.");
			return null;
		}

		const metaData = target.metaData && typeof target.metaData === "object"
			? _.cloneDeep(target.metaData)
			: {};
		const title = this.cleanMetadataTitle(this.state.metadataEditorTitle);
		const description = this.cleanMetadataDescription(this.state.metadataEditorDescription);
		const transcript = this.cleanMetadataTranscript(this.state.metadataEditorTranscript);
		const transcriptVtt = this.cleanMetadataTranscriptVtt(this.state.metadataEditorTranscriptVtt);
		const tags = this.mergeUniqueMetadataTags(this.state.metadataEditorPrimaryTags || []);

		metaData.tags = tags;
		if (title) {
			metaData.title = title;
		} else {
			delete metaData.title;
		}
		if (description) {
			metaData.description = description;
		} else {
			delete metaData.description;
		}
		if (transcript) {
			metaData.transcript = transcript;
		} else {
			delete metaData.transcript;
		}
		if (transcriptVtt) {
			metaData.transcriptVtt = transcriptVtt;
		} else {
			delete metaData.transcriptVtt;
		}

		this.setState({ metadataEditorSaving: true });

		try {
			await refreshCredentials();
			await request
				.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId: getOrgId(),
					path: getFullObjectPath(path),
					metaData
				}));

			await listDriveForSelectedFolderSilently();
			if (target.guid) {
				setActiveTreeCursorForDriveGuid(target.guid);
			} else {
				setActiveTreeCursor({
					...target,
					metaData
				});
			}

			if (showSavedMessage) {
				showSuccess("Metadata", "Metadata saved.");
			}
			const savedTarget = {
				...target,
				metaData
			};
			this.setState({
				metadataEditorSaving: false,
				showMetadataEditorModal: closeModal ? false : true,
				metadataEditorTarget: savedTarget,
				metadataEditorGalleryItems: closeModal ? [] : this.state.metadataEditorGalleryItems
			});
			return savedTarget;
		} catch (err) {
			console.error(err);
			showError("Metadata", `Failed to save metadata: ${err?.message || err}`);
			this.setState({ metadataEditorSaving: false });
			return null;
		}
	}

	handleToggleMediaMetadataPanel() {
		this.setState((prev) => ({
			showMediaMetadataPanel: !prev.showMediaMetadataPanel
		}));
	}

	handleTogglePreviewMetadataField(field) {
		const fieldToStateKey = {
			title: "showPreviewMetadataTitle",
			description: "showPreviewMetadataDescription",
			tags: "showPreviewMetadataTags"
		};
		const stateKey = fieldToStateKey[field];
		if (!stateKey) {
			return;
		}
		this.setState((prev) => ({
			[stateKey]: !prev[stateKey]
		}));
	}

	cleanMetadataText(value) {
		if (typeof value !== "string") {
			return "";
		}
		return value.trim();
	}

	normalizeMetadataTagSource(source) {
		if (!source) {
			return [];
		}
		if (Array.isArray(source)) {
			return source.map((entry) => {
				if (typeof entry === "string") {
					return entry.trim();
				}
				if (entry && typeof entry === "object") {
					const value = entry.label || entry.name || entry.Name || entry.tag || entry.Tag;
					return typeof value === "string" ? value.trim() : "";
				}
				return "";
			}).filter(Boolean);
		}
		if (typeof source === "string") {
			return source
				.split(",")
				.map((entry) => entry.trim())
				.filter(Boolean);
		}
		if (source && typeof source === "object") {
			return Object.keys(source)
				.map((entry) => `${entry}`.trim())
				.filter(Boolean);
		}
		return [];
	}

	mergeUniqueMetadataTags(tags = []) {
		const seen = {};
		const unique = [];
		tags.forEach((tag) => {
			const normalized = `${tag || ""}`.trim();
			if (!normalized) {
				return;
			}
			const key = normalized.toLowerCase();
			if (seen[key]) {
				return;
			}
			seen[key] = true;
			unique.push(normalized);
		});
		return unique;
	}

	getMediaMetadataForResource(resource = null) {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object"
			? resource.metaData
			: {};
		const title = this.cleanMetadataText(metaData.title || "");
		const description = this.cleanMetadataText(metaData.description || "");
		const tags = this.mergeUniqueMetadataTags([
			...this.normalizeMetadataTagSource(metaData.tags),
			...this.normalizeMetadataTagSource(resource?.labels),
			...this.normalizeMetadataTagSource(metaData.openAiTags),
			...this.normalizeMetadataTagSource(metaData.rekognitionTags),
			...this.normalizeMetadataTagSource(metaData.labels),
			...this.normalizeMetadataTagSource(resource?.tags)
		]);

		return { title, description, tags };
	}

	hasAnyMediaMetadata(mediaMetadata = null) {
		if (!mediaMetadata) {
			return false;
		}
		return !!(
			mediaMetadata.title ||
			mediaMetadata.description ||
			(Array.isArray(mediaMetadata.tags) && mediaMetadata.tags.length > 0)
		);
	}

	cleanMetadataTitle(value) {
		const cleaned = this.cleanMetadataText(value);
		return cleaned.length > MAX_METADATA_TITLE_CHARS ? cleaned.slice(0, MAX_METADATA_TITLE_CHARS).trim() : cleaned;
	}

	cleanMetadataDescription(value) {
		const cleaned = this.cleanMetadataText(value);
		return cleaned.length > MAX_METADATA_DESCRIPTION_CHARS ? cleaned.slice(0, MAX_METADATA_DESCRIPTION_CHARS).trim() : cleaned;
	}

	cleanMetadataTranscript(value) {
		const cleaned = this.cleanMetadataText(value);
		return cleaned.length > MAX_METADATA_TRANSCRIPT_CHARS ? cleaned.slice(0, MAX_METADATA_TRANSCRIPT_CHARS).trim() : cleaned;
	}

	cleanMetadataTranscriptVtt(value) {
		let cleaned = this.cleanMetadataText(value);
		if (!cleaned) {
			return "";
		}
		if (/-->/m.test(cleaned) && !/^WEBVTT/i.test(cleaned)) {
			cleaned = `WEBVTT\n\n${cleaned}`;
		}
		return cleaned.length > MAX_METADATA_TRANSCRIPT_VTT_CHARS ? cleaned.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS).trim() : cleaned;
	}

	isMetadataGenerationInProgress(field = "") {
		const current = `${this.state.metadataGeneratingField || ""}`;
		return field ? current === field : current !== "";
	}

	getMetadataResourcePath(resource = null) {
		return this.getDriveResourcePath(resource);
	}

	getMetadataResourceMediaType(resource = null) {
		const target = resource || this.state.metadataEditorTarget || this.resolveDriveSelectionResource();
		if (!target) {
			return "file";
		}
		const metaType = `${_.get(target, "metaData.type", "")}`.trim().toLowerCase();
		if (["image", "video", "audio", "pdf"].includes(metaType)) {
			return metaType;
		}
		const contentType = `${target.contentType || target.mimeType || _.get(target, "metaData.contentType", "") || _.get(target, "metaData.mimeType", "")}`.trim().toLowerCase();
		if (contentType.startsWith("image/")) {
			return "image";
		}
		if (contentType.startsWith("video/")) {
			return "video";
		}
		if (contentType.startsWith("audio/")) {
			return "audio";
		}
		if (contentType === "application/pdf") {
			return "pdf";
		}
		if (typeof target.ext === "string" && target.ext.trim() !== "") {
			try {
				return getMediaType(target.ext) || "file";
			} catch (_err) {
				return "file";
			}
		}
		if (typeof this.props.propName === "string" && this.props.propName.trim() !== "") {
			const byProp = this.props.propName.trim().toLowerCase();
			if (["image", "video", "audio", "pdf", "backgroundaudio"].includes(byProp)) {
				return byProp === "backgroundaudio" ? "audio" : byProp;
			}
		}
		return "file";
	}

	getMetadataResourceS3Key(resource = null) {
		const path = this.getMetadataResourcePath(resource);
		if (!path) {
			return "";
		}
		const pathParts = path
			.trim()
			.replace(/^\/+/, "")
			.split("/")
			.filter(Boolean);
		if (pathParts.length < 2) {
			return path;
		}
		const rootSegment = pathParts[0];
		if (rootSegment !== "private" && rootSegment !== "public") {
			return path;
		}
		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[1] || "");
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				pathParts.splice(1, 0, orgId);
			}
		}
		return pathParts.join("/");
	}

	extractResponsesText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		if (typeof payload.output_text === "string" && payload.output_text.trim() !== "") {
			return payload.output_text;
		}
		if (payload.response && typeof payload.response.output_text === "string" && payload.response.output_text.trim() !== "") {
			return payload.response.output_text;
		}
		if (typeof payload.text === "string" && payload.text.trim() !== "") {
			return payload.text;
		}
		const readOutputArray = (arr) => {
			if (!Array.isArray(arr)) {
				return "";
			}
			const parts = [];
			arr.forEach((entry) => {
				if (!entry) {
					return;
				}
				if (entry.type === "message" && Array.isArray(entry.content)) {
					entry.content.forEach((contentPart) => {
						if (typeof contentPart?.text === "string" && contentPart.text.trim() !== "") {
							parts.push(contentPart.text);
						} else if (typeof contentPart?.value === "string" && contentPart.value.trim() !== "") {
							parts.push(contentPart.value);
						}
					});
					return;
				}
				if (typeof entry.text === "string" && entry.text.trim() !== "") {
					parts.push(entry.text);
				}
			});
			return parts.join("").trim();
		};
		return readOutputArray(payload.output || payload.response?.output);
	}

	async runMetadataResponsesPrompt(promptText = "") {
		const requestBody = {
			model: "gpt-5.4",
			input: [
				{
					role: "user",
					content: [{ type: "input_text", text: promptText }]
				}
			]
		};
		const payload = await getResponsesCreateLambda(JSON.stringify(requestBody), { showAlert: false });
		return this.extractResponsesText(payload);
	}

	buildMetadataGenerationContext() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const title = this.cleanMetadataTitle(this.state.metadataEditorTitle || "");
		const description = this.cleanMetadataDescription(this.state.metadataEditorDescription || "");
		const transcript = this.cleanMetadataTranscript(this.state.metadataEditorTranscript || "");
		const transcriptVtt = this.cleanMetadataTranscriptVtt(this.state.metadataEditorTranscriptVtt || "");
		const tags = this.mergeUniqueMetadataTags(this.state.metadataEditorPrimaryTags || []);
		const mediaType = this.getMetadataResourceMediaType(target);
		const path = this.getMetadataResourcePath(target);

		const contextParts = [
			`File name: ${target?.name || "(unknown)"}`,
			`Media type: ${mediaType}`,
			`Path: ${path || "(unknown)"}`,
			`Current title: ${title || "(none)"}`,
			`Current description: ${description || "(none)"}`,
			`Current transcript available: ${transcript ? "yes" : "no"}`,
			`Current timed transcript (VTT) available: ${transcriptVtt ? "yes" : "no"}`,
			`Current tags: ${tags.length ? tags.join(", ") : "(none)"}`
		];
		if (transcript) {
			const snippet = transcript.length > 2000 ? `${transcript.slice(0, 2000)}\n\n[Transcript truncated.]` : transcript;
			contextParts.push(`Transcript snippet:\n${snippet}`);
		}
		return contextParts.join("\n");
	}

	buildMetadataImageContextHints() {
		const target = this.resolveDriveSelectionResource(this.state.metadataEditorTarget);
		const fileName = `${target?.name || ""}`.trim();
		const rawPath = `${this.getMetadataResourcePath(target) || ""}`.trim();
		const pathParts = rawPath
			.split("/")
			.map((part) => part.trim())
			.filter(Boolean)
			.filter((part, index) => {
				if ((part === "public" || part === "private") && index === 0) {
					return false;
				}
				return !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(part);
			});
		const folderParts = fileName
			? pathParts.filter((part) => part.toLowerCase() !== fileName.toLowerCase())
			: pathParts;
		const contextualFolderHints = folderParts.slice(-4);
		const contextParts = [];

		if (fileName) {
			contextParts.push(`File name hint: ${fileName}`);
		}
		if (rawPath) {
			contextParts.push(`Drive path hint: ${rawPath}`);
		}
		if (contextualFolderHints.length > 0) {
			contextParts.push(`Useful folder context: ${contextualFolderHints.join(" | ")}`);
		}

		return contextParts.join("\n");
	}

	cleanGeneratedTagCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/^[-*•]\s+/, "")
			.replace(/^\d+\.\s+/, "")
			.replace(/^tags?\s*:\s*/i, "")
			.replace(/^["'`]+|["'`]+$/g, "")
			.replace(/\s+/g, " ")
			.trim();
		cleaned = cleaned.replace(/[;,.\-:]+$/g, "").trim();
		if (!cleaned || cleaned.length > 80) {
			return "";
		}
		return cleaned;
	}

	parseGeneratedTags(responseText = "") {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return [];
		}
		const tags = [];
		const addTags = (entries = []) => {
			entries.forEach((entry) => {
				const cleaned = this.cleanGeneratedTagCandidate(entry);
				if (cleaned) {
					tags.push(cleaned);
				}
			});
		};

		const normalizedText = responseText
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.trim();
		const lines = normalizedText.split("\n").map((line) => line.trim()).filter(Boolean);
		for (let i = 0; i < Math.min(lines.length, 12); i++) {
			const line = lines[i].replace(/^assistant:\s*/i, "").replace(/^tags?\s*:\s*/i, "");
			if (line.indexOf(",") > -1) {
				addTags(line.split(","));
				if (tags.length >= 3) {
					break;
				}
			}
		}
		if (!tags.length && lines.length) {
			addTags(lines[0].split(","));
		}
		return this.mergeUniqueMetadataTags(tags).slice(0, 25);
	}

	extractAwsTranscribeText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		const directText =
			payload.text ||
			payload.transcript ||
			payload.output_text ||
			payload.content ||
			payload?.results?.transcripts?.[0]?.transcript ||
			"";
		if (typeof directText === "string" && directText.trim() !== "") {
			return directText.trim();
		}
		return this.extractResponsesText(payload);
	}

	extractAwsTranscribeVtt(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return /-->/m.test(payload) ? payload : "";
		}
		const candidates = [payload.vtt, payload.transcriptVtt, payload.transcript_vtt, payload.output_vtt, payload.outputVtt, payload.text];
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			if (typeof candidate === "string" && /-->/m.test(candidate)) {
				return candidate;
			}
		}
		return "";
	}

	extractTranscriptFromVtt(vttValue = "") {
		const normalized = `${vttValue || ""}`.replace(/\r\n/g, "\n");
		if (!normalized.trim()) {
			return "";
		}
		const lines = normalized
			.split("\n")
			.map((line) => line.trim())
			.filter((line) => line !== "")
			.filter((line) => !/^WEBVTT$/i.test(line))
			.filter((line) => !/^NOTE\b/i.test(line))
			.filter((line) => !/^\d+$/.test(line))
			.filter((line) => !/^\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}\s+-->\s+\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}/.test(line));
		return lines.join(" ").replace(/\s+/g, " ").trim();
	}

	extractTagsFromRekognitionPayload(payload) {
		if (!payload) {
			return [];
		}
		if (typeof payload === "string") {
			return this.mergeUniqueMetadataTags(this.normalizeMetadataTagSource(payload));
		}
		const tags = [];
		const addTag = (value) => {
			const normalized = this.cleanGeneratedTagCandidate(`${value || ""}`);
			if (normalized) {
				tags.push(normalized);
			}
		};
		this.normalizeMetadataTagSource(payload.tags || []).forEach(addTag);
		this.normalizeMetadataTagSource(payload.rekognitionTags || []).forEach(addTag);
		this.normalizeMetadataTagSource(payload.openAiTags || []).forEach(addTag);
		(Array.isArray(payload.labels) ? payload.labels : []).forEach((labelEntry) => {
			if (typeof labelEntry === "string") {
				addTag(labelEntry);
			} else if (labelEntry && typeof labelEntry === "object") {
				addTag(labelEntry.Name || labelEntry.name);
			}
		});
		(Array.isArray(payload.Labels) ? payload.Labels : []).forEach((labelEntry) => {
			if (labelEntry && typeof labelEntry === "object") {
				addTag(labelEntry.Name || labelEntry.name);
			}
		});
		return this.mergeUniqueMetadataTags(tags).slice(0, 25);
	}

	handleChangeUrl(e) {
		this.handleChangeProperty(this.props.propName, e.target.value);
	}

	handlePaste() {
		const clipboardValue = getClipboardValueForMediaResource();
		if (!_.isNil(clipboardValue)) {
			this.handleReplaceValue(clipboardValue);
		}
	}

	onDocumentLoad(pdfInfo) {
		console.log("PDF loaded", pdfInfo);
		this.setState({
			pdfInfo
		});
	}
	handleQuickUpload(autoSelect = true) {
		const { accept } = this.props;
		let _accept = accept;
		if (!_accept) {
			_accept = "*/*";
		}
		const input = this.fileUploadField.current;
		if (input) {
			input.accept = _accept;
			input.click();
			this.setState({
				quickUploadAutoSelect: autoSelect
			});
		}
	}

	handleChangeProperty(propName, propValue) {
		if (this.props.onChange && _.isFunction(this.props.onChange)) {
			this.props.onChange(propValue);
		} else {
			this.props.dispatch(
				handleChangeProperty,
				propName,
				propValue
			);
		}
	}

	handleReplaceValue(newVal) {
		this.handleChangeProperty(this.props.propName, newVal);
	}

	handleReplaceExisting(path) {
		console.log("replace existing", path);
		const { accept } = this.props;
		let _accept = accept;
		if (!_accept) {
			_accept = "*/*";
		} else {
			_accept = _accept.replace("/*", "/" + _.last(path.split(".")));
		}
		const input = this.fileUploadField.current;
		if (input) {
			input.accept = _accept;
			input.click();
		}
		this.setState({
			replaceExistingTarget: path
		});
	}

	handleQuickUploadSubmit(event, overrides = {}) {
		const files = _.get(event, "target.files") ? Array.from(event.target.files) : [];
		if (this.shouldPromptForVideoOptions(files, overrides)) {
			this.queueVideoProcessingOptions(files, overrides);
			return;
		}
		this.performQuickUploadFiles(files, overrides);
	}

	handleShowGenerateTtsAudioForPropertyModal(propName) {
		this.props.dispatch(handleShowGenerateTtsAudioForPropertyModal, propName);
	}

	pasteFunction(event) {
		let self = this;
		// consider the first item (can be easily extended for multiple items)
		let item = event.pasteEvent.clipboardData.items[0];

		if (this.state.showPasteImageModal) {

			this.setState({
				showPasteImageModal: false
			});

			if (item && item.type.indexOf("image") === 0) {
				let blob = item.getAsFile();

				/*
				var reader = new FileReader();
				reader.onload = function (event) {
					console.log(event.target.result);				
				};
				reader.readAsDataURL(blob);
				*/

				let overrides = { notOptimized: true };

				if (event.imageName) {
					overrides.fileName = event.imageName;
				} else {
					overrides.fileName = generatePastedImageFileName();
				}

				self.handleQuickUploadSubmit({
					target: {
						files: [blob]
					}
				}, overrides);

			} else if (event.pasteEvent.clipboardData.files.length > 0) {

				let pastedFile = event.pasteEvent.clipboardData.files[0];

				let overrides = { notOptimized: true };

				if (event.imageName) {
					overrides.fileName = event.imageName;
				} else {
					overrides.fileName = generatePastedImageFileName(); //clipboard always returns png
				}

				if (pastedFile.type.indexOf("image") === 0) {
					self.handleQuickUploadSubmit({
						target: {
							files: [pastedFile]
						}
					}, overrides);
				}


			} else {
				console.log("Skipping paste for item", item);
				showError("Error", "Paste image failed, no image data found.");
			}
		}
	}

	handleToggleVideoAdvancedOptions(event) {
		const enabled = !!_.get(event, "target.checked", false);
		setVideoAdvancedOptionsEnabled(enabled);
		this.setState({
			showAdvancedVideoOptions: enabled
		});
	}

	shouldPromptForVideoOptions(files = [], overrides = {}) {
		if (!this.isMediaToolsEnabled()) {
			return false;
		}

		const file = Array.isArray(files) ? files[0] : null;
		const propName = overrides.propName || this.props.propName;
		return shouldPromptForVideoProcessing({
			file,
			propName,
			accept: this.props.accept || "",
			showAdvanced: this.state.showAdvancedVideoOptions,
			skipOptimization: isMediaOptimizationDisabled() || overrides.notOptimized
		});
	}

	async queueVideoProcessingOptions(files = [], overrides = {}) {
		let orientationSummary = getDefaultVideoOrientationSummary(Array.isArray(files) ? files.length : 0);
		try {
			orientationSummary = await summarizeVideoFileOrientations(files);
		} catch (err) {
			console.warn("Unable to detect video orientation for upload options", err);
		}

		this.setState({
			showVideoProcessingOptionsModal: true,
			pendingVideoUpload: {
				files: Array.from(files || []),
				overrides: { ...overrides },
				orientationSummary
			}
		});
	}

	handleCloseVideoProcessingOptionsModal() {
		if (this.fileUploadField && this.fileUploadField.current) {
			this.fileUploadField.current.value = "";
		}
		this.setState({
			showVideoProcessingOptionsModal: false,
			pendingVideoUpload: null
		});
	}

	handleContinueVideoProcessingOptionsModal(options) {
		const pendingVideoUpload = this.state.pendingVideoUpload;
		setStoredVideoProcessingOptions(options);
		this.setState({
			showVideoProcessingOptionsModal: false,
			pendingVideoUpload: null
		}, () => {
			if (pendingVideoUpload) {
				const outputFileName = `${options && options.outputFileName ? options.outputFileName : ""}`.trim();
				this.performQuickUploadFiles(pendingVideoUpload.files, {
					...pendingVideoUpload.overrides,
					...(outputFileName ? { fileName: outputFileName } : {}),
					videoProcessingOptions: options
				});
			}
		});
	}

	getVideoProcessingUploadStateKey(props = this.props) {
		const propName = `${_.get(props, "propName", "video")}`.trim() || "video";
		return `${propName}Processing`;
	}

	getCurrentProcessingUpload(props = this.props) {
		const stateKey = this.getVideoProcessingUploadStateKey(props);
		return _.get(props, ["uploadStatus", stateKey], null) || this.state.processingUpload || null;
	}

	isPreparingVideoProcessingQueue(processingUpload = null) {
		return `${_.get(processingUpload, "queueStatus", "")}`.trim() === "preparing";
	}

	setPreparingVideoEditProcessing(videoEditorSource = null, outputFileName = "", videoProcessingOptions = null) {
		const resource = videoEditorSource && videoEditorSource.resource ? videoEditorSource.resource : null;
		const guid = `${_.get(resource, "guid", "")}`.trim();
		if (!guid) {
			return;
		}

		const preparingUpload = {
			guid,
			path: this.getDriveResourcePath(resource),
			name: outputFileName || videoEditorSource.videoFileName || videoEditorSource.label || "video.mp4",
			startRevision: Number(_.get(resource, "revision")) || 0,
			sourceFileName: outputFileName || videoEditorSource.videoFileName || videoEditorSource.label || "video.mp4",
			description: this.describeVideoProcessingOptions(videoProcessingOptions),
			queueStatus: "preparing",
			startedAt: Date.now()
		};
		const entityId = `${this.props.entityId || ""}`.trim();
		const processingStateKey = this.getVideoProcessingUploadStateKey();
		if (entityId) {
			setUploadingProps(entityId, processingStateKey, preparingUpload);
		}
		this.setState({
			processingUpload: preparingUpload,
			processingStatusNow: Date.now()
		}, this.startVideoProcessingElapsedTimer);
	}

	clearVideoProcessingUpload() {
		const entityId = `${this.props.entityId || ""}`.trim();
		const processingStateKey = this.getVideoProcessingUploadStateKey();
		if (entityId) {
			setUploadingProps(entityId, processingStateKey, null);
		}
		this.stopVideoProcessingPoll();
		this.stopVideoProcessingElapsedTimer();
		this.setState({
			processingUpload: null
		});
	}

	getVideoProcessingOptionLabel(options = [], value = "", fallback = "") {
		const match = Array.isArray(options) ? options.find((option) => option.value === value) : null;
		return match && match.label ? match.label : fallback;
	}

	describeVideoProcessingOptions(options = null) {
		if (!options || typeof options !== "object") {
			return "";
		}

		const details = [];
		const framingLabel = this.getVideoProcessingOptionLabel(VIDEO_FRAMING_PRESET_OPTIONS, options.framingPreset, "");
		if (framingLabel && options.framingPreset && options.framingPreset !== "source") {
			details.push(framingLabel);
		}

		const resizeLabel = this.getVideoProcessingOptionLabel(VIDEO_RESIZE_PRESET_OPTIONS, options.resizePreset, "");
		if (resizeLabel && options.resizePreset && options.resizePreset !== "source") {
			details.push(resizeLabel);
		}

		const styleFilterLabel = this.getVideoProcessingOptionLabel(VIDEO_STYLE_FILTER_PRESET_OPTIONS, options.styleFilterPreset, "");
		if (styleFilterLabel && options.styleFilterPreset && options.styleFilterPreset !== "none") {
			details.push(styleFilterLabel);
		}

		const rotationLabel = this.getVideoProcessingOptionLabel(VIDEO_ROTATION_PRESET_OPTIONS, options.rotationPreset, "");
		if (rotationLabel && options.rotationPreset && options.rotationPreset !== "source") {
			details.push(rotationLabel);
		}

		if (options.autoCropBlackBars === true) {
			details.push("Auto crop black bars");
		}

		const audioLabel = getVideoAudioProcessingLabel(options);
		if (audioLabel) {
			details.push(audioLabel);
		}

		const toneMapLabel = this.getVideoProcessingOptionLabel(VIDEO_TONE_MAP_PRESET_OPTIONS, options.hdrToneMapPreset, "");
		if (toneMapLabel) {
			details.push(toneMapLabel);
		}

		if (Number(options.trimStartSeconds) > 0 || Number(options.trimDurationSeconds) > 0) {
			details.push(`Trim ${Number(options.trimStartSeconds || 0).toFixed(1)}s${Number(options.trimDurationSeconds) > 0 ? ` + ${Number(options.trimDurationSeconds).toFixed(1)}s` : " to end"}`);
		}

		if (options.createThumbnailArtifact === true) {
			details.push("Create JPEG thumbnail artifact");
			if (Number(options.thumbnailFrameSeconds) > 0) {
				details.push(`Thumbnail at ${Number(options.thumbnailFrameSeconds).toFixed(1)}s`);
			}
			if (options.autoLinkThumbnailArtifact === true && this.props.videoThumbnailTargetPropName) {
				details.push(`Auto-link to ${this.props.videoThumbnailTargetPropName}`);
			}
		}

		return details.join(" | ");
	}

	registerPendingVideoProcessingUpload(uploadResponse, file, videoProcessingOptions = null) {
		if (!uploadResponse || !uploadResponse.guid || !isVideoFileCandidate(file)) {
			return;
		}

		const resolvedUploadedResource =
			getDriveObject(uploadResponse.guid) ||
			getDriveObjectByPath(uploadResponse.path || "", true) ||
			null;
		const resolvedStartRevision = Math.max(
			Number(uploadResponse.revision) || 0,
			Number(_.get(resolvedUploadedResource, "revision")) || 0
		);
		const thumbnailPath = videoProcessingOptions && videoProcessingOptions.createThumbnailArtifact
			? buildThumbnailArtifactPath(uploadResponse.path || "")
			: "";
		const existingThumbnailResource = thumbnailPath ? getDriveObjectByPath(thumbnailPath) : null;
		const pendingUpload = {
			guid: uploadResponse.guid,
			path: uploadResponse.path || "",
			name: uploadResponse.fileName || file.name || "video",
			startRevision: resolvedStartRevision,
			masterPath: `${uploadResponse.masterPath || ""}`.trim(),
			sourceFileName: `${file && file.name ? file.name : ""}`.trim(),
			thumbnailPath,
			thumbnailStartGuid: `${_.get(existingThumbnailResource, "guid", "")}`.trim(),
			thumbnailStartRevision: Number(_.get(existingThumbnailResource, "revision")) || 0,
			autoLinkThumbnailArtifact: !!(videoProcessingOptions && videoProcessingOptions.createThumbnailArtifact && videoProcessingOptions.autoLinkThumbnailArtifact),
			description: this.describeVideoProcessingOptions(videoProcessingOptions),
			startedAt: Date.now()
		};
		const entityId = `${this.props.entityId || ""}`.trim();
		const processingStateKey = this.getVideoProcessingUploadStateKey();
		if (entityId) {
			setUploadingProps(entityId, processingStateKey, pendingUpload);
		}
		this.setState({
			processingUpload: pendingUpload
		}, this.scheduleVideoProcessingPoll);
	}

	stopVideoProcessingPoll() {
		if (this.videoProcessingPollTimeout) {
			clearTimeout(this.videoProcessingPollTimeout);
			this.videoProcessingPollTimeout = null;
		}
		this.videoProcessingPollInFlight = false;
	}

	startVideoProcessingElapsedTimer() {
		if (this.videoProcessingElapsedInterval || !this.getCurrentProcessingUpload()) {
			return;
		}

		this.videoProcessingElapsedInterval = setInterval(() => {
			if (!this.getCurrentProcessingUpload()) {
				this.stopVideoProcessingElapsedTimer();
				return;
			}

			this.setState({
				processingStatusNow: Date.now()
			});
		}, 1000);
	}

	stopVideoProcessingElapsedTimer() {
		if (this.videoProcessingElapsedInterval) {
			clearInterval(this.videoProcessingElapsedInterval);
			this.videoProcessingElapsedInterval = null;
		}
	}

	scheduleVideoProcessingPoll(delay = 4000) {
		const processingUpload = this.getCurrentProcessingUpload();
		if (!processingUpload || this.isPreparingVideoProcessingQueue(processingUpload) || this.videoProcessingPollTimeout) {
			return;
		}

		this.videoProcessingPollTimeout = setTimeout(() => {
			this.videoProcessingPollTimeout = null;
			this.pollVideoProcessingUpload();
		}, delay);
	}

	async pollVideoProcessingUpload() {
		const processingUpload = this.getCurrentProcessingUpload();
		if (!processingUpload || this.videoProcessingPollInFlight) {
			return;
		}

		this.videoProcessingPollInFlight = true;
			try {
				await listDriveMap();
				const latest = getDriveObject(processingUpload.guid);
				const latestRevision = Number(_.get(latest, "revision")) || 0;
				if (latest && latestRevision > (Number(processingUpload.startRevision) || 0)) {
					const thumbnailResource = this.getReadyThumbnailResource(processingUpload);
					if (processingUpload.thumbnailPath && !thumbnailResource) {
						this.scheduleVideoProcessingPoll(2000);
						return;
					}
					if (thumbnailResource && processingUpload.autoLinkThumbnailArtifact) {
						this.syncThumbnailTargetReference(processingUpload, thumbnailResource);
					}
					const entityId = `${this.props.entityId || ""}`.trim();
					const processingStateKey = this.getVideoProcessingUploadStateKey();
					if (entityId) {
						setUploadingProps(entityId, processingStateKey, null);
					}
					await new Promise((resolve) => this.setState({
						processingUpload: null
					}, resolve));
					this.refreshCompletedVideoProcessingUi(processingUpload, latest, thumbnailResource).catch((error) => {
						console.warn("Unable to finalize authoring video processing refresh", error);
					});
					return;
				}

			this.scheduleVideoProcessingPoll();
		} catch (error) {
			console.warn("Unable to refresh authoring video processing status", error);
			this.scheduleVideoProcessingPoll(6000);
		} finally {
			this.videoProcessingPollInFlight = false;
		}
	}

	async refreshCompletedVideoProcessingUi(processingUpload = null, latestResource = null, thumbnailResource = null) {
		try {
			await this.refreshVideoPreviewResolvedUrlForResource(latestResource);
		} catch (error) {
			console.warn("Unable to refresh authoring video preview URL after conversion", error);
		}

		try {
			await listDriveForSelectedFolderSilently();
			if (thumbnailResource && thumbnailResource.guid && processingUpload && processingUpload.autoLinkThumbnailArtifact) {
				setActiveTreeCursorForDriveGuid(thumbnailResource.guid);
			}
		} catch (error) {
			console.warn("Unable to refresh selected Drive folder after conversion", error);
		}
	}

	getPendingVideoProcessingForResource(resource = null) {
		const pending = this.getCurrentProcessingUpload();
		const guid = `${_.get(resource, "guid", "")}`.trim();
		if (!pending || !guid) {
			return null;
		}
		return pending.guid === guid ? pending : null;
	}

	getReadyThumbnailResource(processingUpload = null) {
		const thumbnailPath = `${_.get(processingUpload, "thumbnailPath", "")}`.trim();
		if (!thumbnailPath) {
			return null;
		}

		const thumbnailResource = getDriveObjectByPath(thumbnailPath);
		if (!thumbnailResource) {
			return null;
		}

		const startGuid = `${_.get(processingUpload, "thumbnailStartGuid", "")}`.trim();
		const startRevision = Number(_.get(processingUpload, "thumbnailStartRevision")) || 0;
		const currentGuid = `${_.get(thumbnailResource, "guid", "")}`.trim();
		const currentRevision = Number(_.get(thumbnailResource, "revision")) || 0;
		if (!startGuid) {
			return thumbnailResource;
		}
		if (currentGuid && currentGuid !== startGuid) {
			return thumbnailResource;
		}
		if (currentRevision > startRevision) {
			return thumbnailResource;
		}
		return null;
	}

	getVideoProcessingFeedback(processingInfo = null) {
		return getVideoProcessingStatusFeedback(processingInfo, this.state.processingStatusNow || Date.now());
	}

	async handleRefreshVideoProcessingStatus() {
		const processingUpload = this.getCurrentProcessingUpload();
		if (!processingUpload || this.isPreparingVideoProcessingQueue(processingUpload)) {
			return;
		}

		this.stopVideoProcessingPoll();
		await this.pollVideoProcessingUpload();
		this.setState({
			processingStatusNow: Date.now()
		});
	}

	renderVideoProcessingStatusMeta(processingInfo = null, options = {}) {
		const feedback = this.getVideoProcessingFeedback(processingInfo);
		if (!feedback) {
			return null;
		}

		const textColor = options.textColor || "#1f4f82";
		const chipBackground = options.chipBackground || "rgba(255, 255, 255, 0.55)";
		const chipBorder = options.chipBorder || "rgba(31, 79, 130, 0.18)";
		const showRefresh = options.showRefresh === true;
		const isPreparing = this.isPreparingVideoProcessingQueue(processingInfo);
		const metaItems = [];
		if (feedback.elapsedLabel) {
			metaItems.push(`Elapsed ${feedback.elapsedLabel}`);
		}
		if (feedback.startedLabel) {
			metaItems.push(`Started ${feedback.startedLabel}`);
		}
		if (feedback.autoCheckLabel) {
			metaItems.push(feedback.autoCheckLabel);
		}
		if (feedback.sourceLabel) {
			metaItems.push(`Source ${feedback.sourceLabel}`);
		}

		return (
			<div style={{ marginTop: "8px", display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
				{metaItems.map((item) => (
					<div
						key={item}
						style={{
							padding: "4px 8px",
							borderRadius: "999px",
							background: chipBackground,
							border: `1px solid ${chipBorder}`,
							fontSize: "12px",
							lineHeight: 1.4,
							color: textColor
						}}
					>
						{item}
					</div>
				))}
				{showRefresh && !isPreparing && (
					<Button bsSize="xsmall" onClick={this.handleRefreshVideoProcessingStatus}>
						<FontAwesomeIcon icon="sync" style={{ marginRight: "6px" }} />
						Check Again Now
					</Button>
				)}
			</div>
			);
		}

	syncThumbnailTargetReference(processingUpload = null, thumbnailResource = null) {
		const targetPropName = `${this.props.videoThumbnailTargetPropName || ""}`.trim();
		if (!targetPropName || !thumbnailResource) {
			return;
		}

		const entity = this.getSelectedNodeEntity();
		const currentTargetValue = entity ? entity[targetPropName] : null;
		if (!currentTargetValue) {
			injectExternalResourceReference(targetPropName, thumbnailResource, getSelectedNodePath());
			return;
		}

		if (!isDriveReference(currentTargetValue)) {
			return;
		}

		let currentTargetResource = null;
		try {
			currentTargetResource = getDriveObjectForReference(currentTargetValue);
		} catch (err) {
			console.warn(err);
		}

		const currentTargetPath = this.getDriveResourcePath(currentTargetResource);
		const expectedThumbnailPath = `${_.get(processingUpload, "thumbnailPath", "")}`.trim();
		const currentSourceVideoGuid = `${_.get(currentTargetResource, "metaData.sourceVideoDriveObjectGuid", "")}`.trim();
		const currentIsVideoThumbnail = `${_.get(currentTargetResource, "metaData.derivedArtifact", "")}`.trim() === "video-thumbnail";
		const currentGuid = `${_.get(currentTargetResource, "guid", "")}`.trim();
		const thumbnailGuid = `${_.get(thumbnailResource, "guid", "")}`.trim();
		const currentRevision = Number(_.get(currentTargetResource, "revision")) || 0;
		const thumbnailRevision = Number(_.get(thumbnailResource, "revision")) || 0;

		const shouldReplaceReference =
			(currentTargetPath && expectedThumbnailPath && currentTargetPath === expectedThumbnailPath) ||
			(currentIsVideoThumbnail && currentSourceVideoGuid && currentSourceVideoGuid === `${_.get(processingUpload, "guid", "")}`.trim()) ||
			(currentGuid && thumbnailGuid && currentGuid === thumbnailGuid && currentRevision !== thumbnailRevision);

		if (shouldReplaceReference) {
			injectExternalResourceReference(targetPropName, thumbnailResource, getSelectedNodePath());
		}
	}

	appendRevisionToUrl(url = "", revision = 0) {
		const normalizedUrl = `${url || ""}`.trim();
		if (!normalizedUrl) {
			return "";
		}

		const safeRevision = Number(revision) || 0;
		if (!safeRevision) {
			return normalizedUrl;
		}

		const separator = normalizedUrl.includes("?") ? "&" : "?";
		return `${normalizedUrl}${separator}v=${safeRevision}`;
	}

	async refreshVideoPreviewResolvedUrlForResource(resource = null) {
		const target = resource || this.getDriveResourceFromValue();
		const guid = `${_.get(target, "guid", "")}`.trim();
		const revision = Number(_.get(target, "revision")) || 0;
		if (!guid || !revision) {
			return false;
		}

		if (
			this.state.videoPreviewResolvedUrl &&
			this.state.videoPreviewResolvedGuid === guid &&
			(Number(this.state.videoPreviewResolvedRevision) || 0) === revision &&
			(Number(this.state.videoPreviewResolvedExpiresAt) || 0) > Date.now()
		) {
			return true;
		}

		const expiresInSeconds = 3600;
		await refreshCredentials();
		let nextUrl = getSignedDriveResourceUrl(target, expiresInSeconds);

		if (!nextUrl && env?.apiGateway?.endpoints?.drive?.getObjectUrl) {
			const response = await request
				.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.getObjectUrl(guid)}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" });
			nextUrl = typeof response?.body === "string"
				? response.body
				: `${response?.body?.url || response?.body?.presignedUrl || response?.text || ""}`.trim();
		}

		nextUrl = this.appendRevisionToUrl(nextUrl, revision);
		if (!nextUrl) {
			return false;
		}

		await new Promise((resolve) => {
			this.setState({
				videoPreviewResolvedUrl: nextUrl,
				videoPreviewResolvedGuid: guid,
				videoPreviewResolvedRevision: revision,
				videoPreviewResolvedExpiresAt: Date.now() + (expiresInSeconds * 1000)
			}, resolve);
		});
		return true;
	}

	getResolvedVideoPreviewUrl(defaultUrl = "", resource = null) {
		const target = resource || this.getDriveResourceFromValue();
		const guid = `${_.get(target, "guid", "")}`.trim();
		const revision = Number(_.get(target, "revision")) || 0;
		if (
			defaultUrl &&
			this.state.videoPreviewResolvedUrl &&
			this.state.videoPreviewResolvedGuid === guid &&
			(Number(this.state.videoPreviewResolvedRevision) || 0) === revision &&
			(Number(this.state.videoPreviewResolvedExpiresAt) || 0) > Date.now()
		) {
			return this.state.videoPreviewResolvedUrl;
		}
		return defaultUrl;
	}

	performQuickUploadFiles(files = [], overrides = {}) {
		const file = Array.isArray(files) ? files[0] : null;
		const nodePath = getSelectedNodePath();
		console.log("Got files", file, this.state.config);
		let fileName = (overrides.fileName) ? overrides.fileName : (file ? file.name : "");
		if (file && fileName) {
			const propName = overrides.propName || this.props.propName;
			const autoLink = overrides.hasOwnProperty("autoLink") ? overrides.autoLink : this.state.quickUploadAutoSelect;
			this.setState({
				uploading: true
			});
			const driveRootPath = getDriveRootPath(true);
			console.log(driveRootPath);
			const replaceExistingTarget = overrides.replaceExistingTarget || this.state.replaceExistingTarget;
			const isReplace = !!replaceExistingTarget;
			let targetPath = isReplace ? replaceExistingTarget : `private/activities/${driveRootPath}`;
			const isQuickMobileUpload = !isReplace && isMobile();
			if (isQuickMobileUpload) {
				let newExt;
				if (propName === "video") {
					newExt = "mp4";
				} else if (propName === "audio" || propName === "backgroundAudio") {
					newExt = "mp3";
				} else {
					newExt = `${_.last(fileName.split("."))}`;
				}

				targetPath = `${targetPath}/${generateUUID()}.${newExt}`;
			}

			const func = (isMediaOptimizationDisabled() || overrides.notOptimized) ? uploadFile : uploadAndOptimizeMediaFile;
			func(targetPath, file, propName, isReplace || isQuickMobileUpload, overrides).then((uploadResponse) => {
				if (!isMediaOptimizationDisabled() && !overrides.notOptimized && propName === "video") {
					this.registerPendingVideoProcessingUpload(uploadResponse, file, overrides.videoProcessingOptions);
				}
				if (autoLink) {
					const uploadedResource =
						(uploadResponse && uploadResponse.guid ? getDriveObject(uploadResponse.guid) : null) ||
						getDriveObjectByPath(uploadResponse.path, propName === "video");
					if (!uploadedResource) {
						throw new Error(`Upload succeeded but the new Drive object could not be resolved for ${uploadResponse.path || "uploaded file"}.`);
					}
					injectExternalResourceReference(propName, uploadedResource, nodePath);
				}
				this.setState({
					uploading: false,
					replaceExistingTarget: null
				});
				this.fileUploadField.current.value = "";

			}).catch(err => {
				showError("Upload File", "An error occurred while attempting to upload the file. Error: " + err);
			});
		} else {
			showError("Upload File", "Need to select a folder and specify a file to upload");
		}
	}

	handleShowPasteImageModal() {
		this.setState({
			showPasteImageModal: true,
			quickUploadAutoSelect: true //need to do this so inline file picker path is always updated
		});
	}

	handleShowAiImageGeneratorModal() {
		this.setState({
			showAiImageGeneratorModal: true
		});
	}

	handleShowImageEditorModal(targetPropName = null) {
		if (!this.isImageToolsEnabled()) {
			return;
		}

		if (!this.canEditCurrentImage()) {
			showError("Edit Image", "This item needs an image before it can be edited.");
			return;
		}

		this.setState({
			showImageEditorModal: true,
			imageEditorTargetPropName: targetPropName || this.props.propName,
			quickUploadAutoSelect: true
		});
	}

	handleShowVideoThumbnailModal(targetPropName = null) {
		if (!this.isImageToolsEnabled()) {
			return;
		}

		if (!this.canCreateVideoThumbnail()) {
			showError("Create Video Thumbnail", "This item needs a video before a thumbnail can be created.");
			return;
		}

		this.setState({
			showVideoThumbnailModal: true,
			videoThumbnailTargetPropName: targetPropName || this.props.videoThumbnailTargetPropName || this.props.propName,
			quickUploadAutoSelect: true
		});
	}

	handleShowVideoEditorModal() {
		if (!this.isMediaToolsEnabled()) {
			return;
		}

		if (!this.canEditCurrentVideo()) {
			showError("Edit Video", "This item needs a Drive-backed video before it can be edited.");
			return;
		}

		this.setState({
			showVideoEditorModal: true
		});
	}

	handleShowVideoChunkModal() {
		if (!this.isMediaToolsEnabled()) {
			return;
		}

		if (!this.canChunkCurrentVideo()) {
			showError("Chunk Video", "Chunk Video currently requires a Drive-backed video on this item.");
			return;
		}

		this.setState({
			showVideoChunkModal: true
		});
	}

	handleClosePasteImageModal() {
		this.setState({
			showPasteImageModal: false
		});
	}


	handleCloseAiImageGeneratorModal() {
		this.setState({
			showAiImageGeneratorModal: false
		});
	}

	handleCloseImageEditorModal() {
		this.setState({
			showImageEditorModal: false,
			imageEditorTargetPropName: null
		});
	}

	handleCloseVideoThumbnailModal() {
		this.setState({
			showVideoThumbnailModal: false,
			videoThumbnailTargetPropName: null
		});
	}

	handleCloseVideoEditorModal() {
		this.setState({
			showVideoEditorModal: false
		});
	}

	handleCloseVideoChunkModal() {
		this.setState({
			showVideoChunkModal: false
		});
	}

	handleShowMarkupImageModal(version = MEDIA_MARKUP_MODAL_VERSION_V2) {
		const requestedVersion = version === MEDIA_MARKUP_MODAL_VERSION_LEGACY || !this.isMediaMarkupV2Enabled()
			? MEDIA_MARKUP_MODAL_VERSION_LEGACY
			: MEDIA_MARKUP_MODAL_VERSION_V2;
		this.setState({
			showMarkupImageModal: true,
			markupImageModalVersion: requestedVersion
		});
	}

	handleCloseMarkupImageModal() {
		this.setState({
			showMarkupImageModal: false,
			markupImageModalVersion: MEDIA_MARKUP_MODAL_VERSION_V2
		});
	}

	handleCreateVideoThumbnail({ blob, imageName, autoLink = true }) {
		if (!blob) {
			showError("Create Video Thumbnail", "Unable to create thumbnail image.");
			return;
		}

		const targetPropName = this.state.videoThumbnailTargetPropName || this.props.videoThumbnailTargetPropName || this.props.propName;
		const safeFileName = `${imageName || "video-thumbnail.jpg"}`.trim() || "video-thumbnail.jpg";
		const file = new File([blob], safeFileName, { type: "image/jpeg" });

		this.setState({
			showVideoThumbnailModal: false,
			videoThumbnailTargetPropName: null,
			quickUploadAutoSelect: !!autoLink
		});

		this.handleQuickUploadSubmit({
			target: {
				files: [file]
			}
		}, {
			fileName: safeFileName,
			propName: targetPropName,
			autoLink,
			notOptimized: true
		});
	}

	buildChunkOutlineLabel(segment = null, index = 0, baseLabel = this.getChunkOutlineLabelBase()) {
		const preferredLabel = `${_.get(segment, "outlineLabel", "")}`.trim();
		return preferredLabel || `${baseLabel} - Step ${index + 1}`;
	}

	getChunkOutlineLabelBase() {
		const selectedEntity = this.getSelectedNodeEntity();
		const preferredLabel = `${_.get(selectedEntity, "label", "") || _.get(selectedEntity, "label1", "") || _.get(selectedEntity, "title", "") || _.get(selectedEntity, "name", "")}`.trim();
		return preferredLabel || "Step";
	}

	buildChunkVideoReference(resource = null) {
		return this.buildChunkResourceReference(resource, "video");
	}

	buildChunkImageReference(resource = null) {
		return this.buildChunkResourceReference(resource, "image");
	}

	buildChunkThumbnailReference(resource = null) {
		return this.buildChunkImageReference(resource);
	}

	buildChunkResourceReference(resource = null, targetPropName = "video") {
		if (!resource || !resource.guid) {
			return null;
		}
		const refId = addExternalResource({
			...resource,
			isVideo: targetPropName === "video"
		});
		return getResourceReference(refId);
	}

	getChunkResourceOutputIndex(resource = null, generationMode = "video-chunks") {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object" ? resource.metaData : {};
		const value = `${generationMode || ""}`.trim() === "keyframes"
			? Number(metaData.keyframeIndex)
			: Number(metaData.chunkIndex);
		return Number.isFinite(value) && value >= 0 ? value : Number.MAX_SAFE_INTEGER;
	}

	sortChunkCreatedResources(createdResources = [], generationMode = "video-chunks") {
		return [...(Array.isArray(createdResources) ? createdResources : [])].sort((a, b) => {
			const indexDifference = this.getChunkResourceOutputIndex(a, generationMode) - this.getChunkResourceOutputIndex(b, generationMode);
			if (indexDifference !== 0) {
				return indexDifference;
			}
			return `${_.get(a, "path", "")}`.localeCompare(`${_.get(b, "path", "")}`);
		});
	}

	applyChunkOutlineLabelToEntity(entity = null, label = "") {
		if (!entity || !_.isObject(entity)) {
			return;
		}
		const resolvedLabel = `${label || ""}`.trim();
		entity.label1 = resolvedLabel;
		entity.label = resolvedLabel;
	}

	applyChunkOutlineMediaToEntity(entity = null, resourceReference = null, generationMode = "video-chunks", thumbnailResourceReference = null) {
		if (!entity || !_.isObject(entity) || !resourceReference) {
			return false;
		}

		if (`${generationMode || ""}`.trim() === "keyframes") {
			entity.image = resourceReference;
			entity.video = "";
			return true;
		}

		entity.video = resourceReference;
		if (thumbnailResourceReference) {
			entity.image = thumbnailResourceReference;
		}
		return true;
	}

	buildChunkVideoSourcePayload(resource = null, segment = null, generationMode = "video-chunks", chunkVideoSourceContext = {}, autoCreateOutline = false, thumbnailResource = null) {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object" ? resource.metaData : {};
		const activeChunkSource = chunkVideoSourceContext && chunkVideoSourceContext.activeChunkSource && typeof chunkVideoSourceContext.activeChunkSource === "object"
			? chunkVideoSourceContext.activeChunkSource
			: null;
		const playbackChunkSource = chunkVideoSourceContext && chunkVideoSourceContext.playbackChunkSource && typeof chunkVideoSourceContext.playbackChunkSource === "object"
			? chunkVideoSourceContext.playbackChunkSource
			: null;
		const masterChunkSource = chunkVideoSourceContext && chunkVideoSourceContext.masterChunkSource && typeof chunkVideoSourceContext.masterChunkSource === "object"
			? chunkVideoSourceContext.masterChunkSource
			: null;
		const normalizedGenerationMode = `${generationMode || ""}`.trim() === "keyframes" ? "keyframes" : "video-chunks";
		const normalizedSourceMode = `${_.get(chunkVideoSourceContext, "sourceMode", "")}`.trim() === "master" ? "master" : "playback";
		const segmentIndex = Number(_.get(segment, "index"));
		const resourceOutputIndex = normalizedGenerationMode === "keyframes"
			? Number(_.get(metaData, "keyframeIndex"))
			: Number(_.get(metaData, "chunkIndex"));
		const resolvedOutputIndex = Number.isFinite(resourceOutputIndex) && resourceOutputIndex >= 0
			? resourceOutputIndex
			: (Number.isFinite(segmentIndex) && segmentIndex >= 0 ? segmentIndex : 0);
		const normalizedVideoProcessing = _.cloneDeep(_.get(metaData, "videoProcessing", _.get(chunkVideoSourceContext, "activeBaseProcessingOptions", {}))) || {};
		const normalizeOptionalNumber = (value) => {
			const parsed = Number(value);
			return Number.isFinite(parsed) ? parsed : null;
		};
		const payload = {
			version: 1,
			generationMode: normalizedGenerationMode,
			sourceMode: normalizedSourceMode,
			useMasterSource: normalizedSourceMode === "master",
			autoCreateOutline: autoCreateOutline === true,
			createdAt: new Date().toISOString(),
			sourcePlaybackGuid: `${_.get(chunkVideoSourceContext, "sourcePlaybackGuid", _.get(metaData, "sourceVideoDriveObjectGuid", ""))}`.trim(),
			sourcePlaybackPath: `${_.get(chunkVideoSourceContext, "sourcePlaybackPath", _.get(metaData, "sourceVideoDrivePath", ""))}`.trim(),
			activeChunkSourceBucket: `${_.get(activeChunkSource, "bucket", "")}`.trim(),
			activeChunkSourcePath: `${_.get(activeChunkSource, "key", "")}`.trim(),
			playbackChunkSourceBucket: `${_.get(playbackChunkSource, "bucket", "")}`.trim(),
			playbackChunkSourcePath: `${_.get(playbackChunkSource, "key", "")}`.trim(),
			masterChunkSourceBucket: `${_.get(masterChunkSource, "bucket", "")}`.trim(),
			masterChunkSourcePath: `${_.get(masterChunkSource, "key", "")}`.trim(),
			baseOutputPath: `${_.get(chunkVideoSourceContext, "baseOutputPath", "")}`.trim(),
			sourceFileName: `${_.get(chunkVideoSourceContext, "fileName", "")}`.trim(),
			outputIndex: resolvedOutputIndex,
			outputFileName: `${_.get(resource, "path", "").split("/").pop() || _.get(resource, "name", "")}`.trim(),
			outputResourceGuid: `${_.get(resource, "guid", "")}`.trim(),
			outputResourcePath: `${_.get(resource, "path", "")}`.trim(),
			thumbnailResourceGuid: `${_.get(thumbnailResource, "guid", "")}`.trim(),
			thumbnailResourcePath: `${_.get(thumbnailResource, "path", "")}`.trim(),
			derivedArtifact: `${_.get(metaData, "derivedArtifact", "")}`.trim(),
			chunkJobId: `${_.get(metaData, "chunkJobId", "")}`.trim(),
			videoProcessing: normalizedVideoProcessing
		};

		if (normalizedGenerationMode === "keyframes") {
			const explicitImageFormat = `${_.get(metaData, "keyframeImageFormat", "")}`.trim().toLowerCase();
			const inferredImageFormat = `${_.get(resource, "path", "")}`.trim().toLowerCase().endsWith(".jpg") ? "jpg" : "png";
			payload.keyframe = {
				index: resolvedOutputIndex,
				suffix: `${_.get(segment, "suffix", _.get(metaData, "keyframeSuffix", ""))}`.trim(),
				frameSeconds: normalizeOptionalNumber(_.get(segment, "frameSeconds", _.get(metaData, "keyframeFrameSeconds")))
			};
			payload.imageFormat = explicitImageFormat || inferredImageFormat;
		} else {
			payload.chunk = {
				index: resolvedOutputIndex,
				suffix: `${_.get(segment, "suffix", _.get(metaData, "chunkSuffix", ""))}`.trim(),
				startSeconds: normalizeOptionalNumber(_.get(segment, "startSeconds", _.get(metaData, "chunkStartSeconds"))),
				endSeconds: normalizeOptionalNumber(_.get(segment, "endSeconds", null)),
				durationSeconds: normalizeOptionalNumber(_.get(segment, "durationSeconds", _.get(metaData, "chunkDurationSeconds")))
			};
		}

		const preferredLabel = `${_.get(segment, "outlineLabel", "")}`.trim();
		if (preferredLabel) {
			payload.outlineLabel = preferredLabel;
		}

		if (_.get(segment, "outlineSectionStart") === true) {
			payload.outlineSection = {
				index: Math.max(0, Number(_.get(segment, "outlineSectionIndex")) || 0),
				title: `${_.get(segment, "outlineSectionTitle", "")}`.trim()
			};
		}

		return payload;
	}

	applyChunkVideoSourceToEntity(entity = null, resource = null, segment = null, generationMode = "video-chunks", chunkVideoSourceContext = {}, autoCreateOutline = false, thumbnailResource = null) {
		if (!entity || !_.isObject(entity)) {
			return;
		}

		entity.chunkVideoSource = this.buildChunkVideoSourcePayload(resource, segment, generationMode, chunkVideoSourceContext, autoCreateOutline, thumbnailResource);
	}

	buildChunkThumbnailResourceMap(createdResources = [], generationMode = "video-chunks") {
		if (`${generationMode || ""}`.trim() !== "video-chunks") {
			return {};
		}

		const sourceVideoGuids = new Set(
			(Array.isArray(createdResources) ? createdResources : [])
				.map((resource) => `${_.get(resource, "guid", "")}`.trim())
				.filter(Boolean)
		);
		if (sourceVideoGuids.size === 0) {
			return {};
		}

		return Object.values(getDriveObjectsAsMap() || {}).reduce((acc, resource) => {
			const derivedArtifact = `${_.get(resource, "metaData.derivedArtifact", "")}`.trim();
			const sourceVideoGuid = `${_.get(resource, "metaData.sourceVideoDriveObjectGuid", "")}`.trim();
			if (derivedArtifact !== "video-thumbnail" || !sourceVideoGuid || !sourceVideoGuids.has(sourceVideoGuid)) {
				return acc;
			}
			acc[sourceVideoGuid] = resource;
			return acc;
		}, {});
	}

	refreshChunkOutlineCloneIds(node = null) {
		if (!node || !_.isObject(node)) {
			return node;
		}

		const refreshedNode = node;
		refreshedNode.id = generateUUID();
		refreshedNode.selected = false;

		if (_.isObject(refreshedNode.entity)) {
			refreshedNode.entity.entityId = generateUUID();
			refreshedNode.entity.guid = generateUUID();
			refreshedNode.entity = fixIftttStructureIds(refreshedNode.entity);
		}

		if (Array.isArray(refreshedNode.children)) {
			refreshedNode.children = refreshedNode.children.map((childNode) => this.refreshChunkOutlineCloneIds(childNode));
		}

		return refreshedNode;
	}

	cloneNodeForChunkOutline(node = null) {
		if (!node) {
			return null;
		}
		return this.refreshChunkOutlineCloneIds(_.cloneDeep(node));
	}

	sanitizeChunkOutlineCloneEntity(entity = null) {
		if (!entity || !_.isObject(entity)) {
			return;
		}

		entity.visible = true;
		entity.label2 = "";
		entity.label2EditorAdvanced = "";
		entity.label2AlexaPlain = "";
		entity.label2AlexaRich = "";
		entity.label2Audio = "";
		entity.label2Ssml = "";
		entity.label2Print = "";
		entity.label2AudioFile = "";
	}

	getChunkOutlineSectionInsertionContext(selectedNodeCursor = null) {
		if (!selectedNodeCursor || !selectedNodeCursor.up || !selectedNodeCursor.up()) {
			return null;
		}

		const siblingsCursor = selectedNodeCursor.up();
		const parentNodeCursor = siblingsCursor.up ? siblingsCursor.up() : null;
		const parentNode = parentNodeCursor && parentNodeCursor.get ? parentNodeCursor.get() : null;
		const parentEntityType = `${_.get(parentNode, "entity.type", "")}`.trim();

		if (parentEntityType === "section") {
			const sectionsCursor = parentNodeCursor.up ? parentNodeCursor.up() : null;
			if (!sectionsCursor) {
				return null;
			}
			parentNodeCursor.set(["entity", "label"], CHUNK_MASTER_VIDEO_SECTION_LABEL);
			return {
				insertCursor: sectionsCursor,
				insertIndex: Number(parentNodeCursor.path[parentNodeCursor.path.length - 1]) + 1,
				sectionTemplateNode: _.cloneDeep(parentNodeCursor.get())
			};
		}

		if (parentEntityType === "checklist") {
			const selectedNode = selectedNodeCursor.get();
			const selectedNodeIndex = Number(selectedNodeCursor.path[selectedNodeCursor.path.length - 1]);
			if (!selectedNode || !Number.isFinite(selectedNodeIndex) || selectedNodeIndex < 0) {
				return null;
			}

			const masterSectionNode = addCategoryNode(addSectionEntity(generateUUID(), CHUNK_MASTER_VIDEO_SECTION_LABEL), true);
			masterSectionNode.expanded = true;
			masterSectionNode.children = [selectedNode];
			siblingsCursor.splice([selectedNodeIndex, 1, masterSectionNode]);
			const masterSectionCursor = siblingsCursor.select(selectedNodeIndex);
			state.set("selectedNodePath", _.concat(siblingsCursor.path, selectedNodeIndex, "children", 0));
			return {
				insertCursor: siblingsCursor,
				insertIndex: selectedNodeIndex + 1,
				sectionTemplateNode: _.cloneDeep(masterSectionCursor.get())
			};
		}

		return null;
	}

	buildChunkOutlineSectionNode(sectionTemplateNode = null, sectionLabel = "", sectionIndex = 0) {
		const fallbackLabel = `${sectionLabel || ""}`.trim() || `Section ${sectionIndex + 1}`;
		const sectionNode = sectionTemplateNode
			? this.cloneNodeForChunkOutline(sectionTemplateNode)
			: addCategoryNode(addSectionEntity(generateUUID(), fallbackLabel), true);
		if (!sectionNode || !sectionNode.entity) {
			return null;
		}

		sectionNode.expanded = true;
		sectionNode.children = [];
		sectionNode.entity.label = fallbackLabel;
		return sectionNode;
	}

	applyChunkOutline(createdResources = [], segments = [], generationMode = "video-chunks", chunkVideoSourceContext = {}, autoCreateOutline = false, chunkThumbnailResourceMap = {}) {
		if (!this.canAutoCreateChunkOutline() || !Array.isArray(createdResources) || createdResources.length === 0) {
			return false;
		}

		const selectedNodePath = getSelectedNodePath();
		if (!Array.isArray(selectedNodePath) || selectedNodePath.length === 0) {
			return false;
		}

		const selectedNodeCursor = state.select(selectedNodePath);
		const selectedNode = selectedNodeCursor.get();
		const selectedEntityType = `${_.get(selectedNode, "entity.type", "")}`.trim();
		if (!selectedEntityType.startsWith("item") || selectedEntityType === "itemContainer") {
			return false;
		}
		const outlineLabelBase = this.getChunkOutlineLabelBase();
		const selectedNodeTemplate = _.cloneDeep(selectedNode);
		const buildResourceReference = `${generationMode || ""}`.trim() === "keyframes"
			? this.buildChunkImageReference
			: this.buildChunkVideoReference;
		const orderedResources = this.sortChunkCreatedResources(createdResources, generationMode);
		const shouldCreateOutlineSections = Array.isArray(segments)
			&& segments.some((segment) => _.get(segment, "outlineSectionStart") === true);

		if (shouldCreateOutlineSections) {
			const sectionInsertionContext = this.getChunkOutlineSectionInsertionContext(selectedNodeCursor);
			if (sectionInsertionContext && sectionInsertionContext.insertCursor) {
				let activeSectionCursor = null;
				let insertIndex = sectionInsertionContext.insertIndex;
				for (let index = 0; index < orderedResources.length; index += 1) {
					const resource = orderedResources[index];
					const resourceReference = buildResourceReference(resource);
					const thumbnailResource = `${generationMode || ""}`.trim() === "video-chunks"
						? chunkThumbnailResourceMap[`${_.get(resource, "guid", "")}`.trim()] || null
						: null;
					const thumbnailResourceReference = thumbnailResource ? this.buildChunkThumbnailReference(thumbnailResource) : null;
					if (!resourceReference) {
						continue;
					}
					const outputIndex = this.getChunkResourceOutputIndex(resource, generationMode);
					const resolvedIndex = Number.isFinite(outputIndex) && outputIndex >= 0 && outputIndex < segments.length
						? outputIndex
						: index;
					const segment = segments[resolvedIndex] || null;

						const clonedNode = this.cloneNodeForChunkOutline(selectedNodeTemplate);
						if (!clonedNode || !clonedNode.entity) {
							continue;
						}
						this.sanitizeChunkOutlineCloneEntity(clonedNode.entity);

						if (!activeSectionCursor || _.get(segment, "outlineSectionStart") === true) {
							const activeSectionNode = this.buildChunkOutlineSectionNode(
							sectionInsertionContext.sectionTemplateNode,
							`${_.get(segment, "outlineSectionTitle", "")}`.trim(),
							Math.max(0, Number(_.get(segment, "outlineSectionIndex")) || 0)
						);
						if (!activeSectionNode) {
							continue;
						}
						sectionInsertionContext.insertCursor.splice([insertIndex, 0, activeSectionNode]);
						activeSectionCursor = sectionInsertionContext.insertCursor.select(insertIndex);
						insertIndex += 1;
					}

					this.applyChunkOutlineMediaToEntity(clonedNode.entity, resourceReference, generationMode, thumbnailResourceReference);
					this.applyChunkOutlineLabelToEntity(clonedNode.entity, this.buildChunkOutlineLabel(segment, resolvedIndex, outlineLabelBase));
					this.applyChunkVideoSourceToEntity(clonedNode.entity, resource, segment, generationMode, chunkVideoSourceContext, autoCreateOutline, thumbnailResource);
					activeSectionCursor.select("children").push(clonedNode);
				}

				state.commit();
				saveUndoState();
				return true;
			}
		}

		const parentCursor = selectedNodeCursor.up();
		let insertIndex = Number(selectedNodeCursor.path[selectedNodeCursor.path.length - 1]) + 1;
		for (let index = 0; index < orderedResources.length; index += 1) {
			const resource = orderedResources[index];
			const resourceReference = buildResourceReference(resource);
			const thumbnailResource = `${generationMode || ""}`.trim() === "video-chunks"
				? chunkThumbnailResourceMap[`${_.get(resource, "guid", "")}`.trim()] || null
				: null;
			const thumbnailResourceReference = thumbnailResource ? this.buildChunkThumbnailReference(thumbnailResource) : null;
			if (!resourceReference) {
				continue;
			}
			const outputIndex = this.getChunkResourceOutputIndex(resource, generationMode);
			const resolvedIndex = Number.isFinite(outputIndex) && outputIndex >= 0 && outputIndex < segments.length
				? outputIndex
				: index;

				const clonedNode = this.cloneNodeForChunkOutline(selectedNodeTemplate);
				if (!clonedNode || !clonedNode.entity) {
					continue;
				}
				this.sanitizeChunkOutlineCloneEntity(clonedNode.entity);

				this.applyChunkOutlineMediaToEntity(clonedNode.entity, resourceReference, generationMode, thumbnailResourceReference);
				this.applyChunkOutlineLabelToEntity(clonedNode.entity, this.buildChunkOutlineLabel(segments[resolvedIndex], resolvedIndex, outlineLabelBase));
			this.applyChunkVideoSourceToEntity(clonedNode.entity, resource, segments[resolvedIndex], generationMode, chunkVideoSourceContext, autoCreateOutline, thumbnailResource);
			parentCursor.splice([insertIndex, 0, clonedNode]);
			insertIndex += 1;
		}

		state.commit();
		saveUndoState();
		return true;
	}

	async handleCreateVideoChunks({ createdResources = [], segments = [], autoCreateOutline = false, generationMode = "video-chunks", chunkVideoSourceContext = {} } = {}) {
		await listDriveMap();
		try {
			await listDriveForSelectedFolderSilently();
		} catch (error) {
			console.warn("Unable to silently refresh selected Drive folder after chunk creation", error);
		}

		const resolvedResources = this.sortChunkCreatedResources((Array.isArray(createdResources) ? createdResources : []).map((resource) => {
			if (!resource || !resource.guid) {
				return null;
			}
			return getDriveObject(resource.guid) || resource;
		}).filter(Boolean), generationMode);

		const createdCount = resolvedResources.length;
		if (createdCount === 0) {
			throw new Error(`${`${generationMode || ""}`.trim() === "keyframes" ? "Keyframe capture" : "Chunk Video"} did not create any Drive resources.`);
		}

		const chunkThumbnailResourceMap = this.buildChunkThumbnailResourceMap(resolvedResources, generationMode);
		const createdThumbnailCount = Object.keys(chunkThumbnailResourceMap).length;

		let outlineApplied = false;
		if (autoCreateOutline === true) {
			outlineApplied = this.applyChunkOutline(resolvedResources, segments, generationMode, chunkVideoSourceContext, autoCreateOutline, chunkThumbnailResourceMap);
		}

		const isKeyframeMode = `${generationMode || ""}`.trim() === "keyframes";

		showSuccess(
			isKeyframeMode ? "Keyframes" : "Chunk Video",
			outlineApplied
				? `Created ${createdCount} ${isKeyframeMode ? "keyframe image" : "chunk video"} artifacts${!isKeyframeMode && createdThumbnailCount > 0 ? `, ${createdThumbnailCount} thumbnail image${createdThumbnailCount === 1 ? "" : "s"}` : ""} and updated the selected activity outline.`
				: `Created ${createdCount} ${isKeyframeMode ? "keyframe image" : "chunk video"} artifacts in Drive.`
		);
	}

	handleCreateEditedImage({ blob, imageName, autoLink = true, overwriteImage = false, overwriteTargetPath = "", mimeType = "" }) {
		if (!blob) {
			showError("Edit Image", "Unable to save edited image.");
			return;
		}

		const targetPropName = this.state.imageEditorTargetPropName || this.props.propName;
		const resolvedMimeType = `${mimeType || blob.type || "image/png"}`.trim() || "image/png";
		const fallbackFileName = resolvedMimeType === "image/jpeg" ? "image-edited.jpg" : "image-edited.png";
		const safeFileName = `${imageName || fallbackFileName}`.trim() || fallbackFileName;
		const file = new File([blob], safeFileName, { type: resolvedMimeType });

		this.setState({
			showImageEditorModal: false,
			imageEditorTargetPropName: null,
			quickUploadAutoSelect: !!autoLink
		});

		this.handleQuickUploadSubmit({
			target: {
				files: [file]
			}
		}, {
			fileName: safeFileName,
			propName: targetPropName,
			autoLink,
			replaceExistingTarget: overwriteImage ? overwriteTargetPath : "",
			notOptimized: true
		});
	}

	async handleCreateEditedVideo(options = {}) {
		const videoEditorSource = this.getAssociatedVideoThumbnailSource();
		const resource = videoEditorSource && videoEditorSource.resource ? videoEditorSource.resource : null;
		if (!resource || !videoEditorSource.drivePath) {
			showError("Edit Video", "Edit Video currently requires a Drive-backed video.");
			return;
		}

		const overwriteVideo = options.overwriteVideo === true;
		const overwriteTargetPath = overwriteVideo ? (options.overwriteTargetPath || videoEditorSource.drivePath) : "";
		const outputFileName = `${options.outputFileName || buildEditedVideoOutputFileName(videoEditorSource.videoFileName || videoEditorSource.label || "video.mp4")}`.trim();
		const videoProcessingOptions = _.omit(options, ["outputFileName", "overwriteVideo", "overwriteTargetPath"]);

		try {
			showInfoToast("Submitting video edit for processing...", {
				autoClose: 5000
			});
			this.setPreparingVideoEditProcessing(videoEditorSource, outputFileName, videoProcessingOptions);
			setStoredVideoProcessingOptions(videoProcessingOptions);
			const uploadResponse = await processExistingDriveVideoFile(resource, {
				outputFileName,
				overwriteTargetPath,
				videoProcessingOptions,
				sourceFileName: videoEditorSource.videoFileName || resource.name || "video.mp4",
				sourceContentType: _.get(resource, "metaData.masterVideoContentType", "") || "video/mp4"
			});

			await listDriveMap();
			try {
				await listDriveForSelectedFolderSilently();
			} catch (err) {
				console.warn("Unable to silently refresh selected Drive folder after editing video", err);
			}

			const uploadedResource =
				(uploadResponse && uploadResponse.guid ? getDriveObject(uploadResponse.guid) : null) ||
				getDriveObjectByPath(uploadResponse.path, true) ||
				uploadResponse;
			if (uploadedResource && uploadedResource.guid) {
				injectExternalResourceReference(this.props.propName, uploadedResource, getSelectedNodePath());
				setActiveTreeCursorForDriveGuid(uploadedResource.guid);
			}

			this.registerPendingVideoProcessingUpload(uploadResponse, {
				name: uploadResponse.fileName || outputFileName,
				type: "video/mp4"
			}, videoProcessingOptions);
			this.setState({
				showVideoEditorModal: false
			});
		} catch (err) {
			if (this.isPreparingVideoProcessingQueue(this.getCurrentProcessingUpload())) {
				this.clearVideoProcessingUpload();
			}
			showError("Edit Video", `An error occurred while attempting to save the edited video. Error: ${err?.message || err}`);
		}
	}

	renderMediaPanel(type, url, driveReference = true, selectedDriveResource = null) {
		let result = <div />;
		const { loading } = this.state;
		const hideViewMediaAction = this.props.hideViewMediaAction === true;
		const pendingProcessing = type === "video" ? this.getPendingVideoProcessingForResource(selectedDriveResource) : null;
		const pendingProcessingFeedback = this.getVideoProcessingFeedback(pendingProcessing);
		const loadingDiv = <div style={{ margin: "15px" }}><FontAwesomeIcon
			icon='spinner'
			spin /> Uploading media asset...</div>;
		const hasDriveFileIdentity =
			!!selectedDriveResource &&
			!!(
				selectedDriveResource.guid ||
				this.getDriveResourcePath(selectedDriveResource) ||
				selectedDriveResource.name
			);
		const isDriveAssetPreview = !driveReference && hasDriveFileIdentity && selectedDriveResource.type !== "folder";
		const mediaMetadata = this.getMediaMetadataForResource(selectedDriveResource);
		const hasMetadata = this.hasAnyMediaMetadata(mediaMetadata);


		let generateTtsAudioMenuItem;
		if (this.props.generateTtsAudio) {
			generateTtsAudioMenuItem = <MenuItem onClick={() => { this.handleShowGenerateTtsAudioForPropertyModal(type); }}><div><FontAwesomeIcon icon={["far", "volume-up"]} />&nbsp;Generate TTS Audio</div></MenuItem>;
		}


		let _createUrlWrapper = driveReference && !!url;
		if (loading) {
			result = loadingDiv;
		} else {
			switch (type) {
				case "video": {
					const videoPlayer = url ? <ReactPlayer key={url} url={url} className="player-video" width="100%" playing={false} playsInline={true} muted={false} loop controls /> : null;
					result = videoPlayer ? (
						<div style={{ position: "relative" }}>
							{videoPlayer}
							{pendingProcessing &&
								<div
									style={{
										position: "absolute",
										inset: 0,
										background: "rgba(14, 27, 42, 0.68)",
										color: "#fff",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
										textAlign: "center",
										padding: "24px",
										gap: "10px",
										zIndex: 2
									}}
									>
										<FontAwesomeIcon icon="spinner" spin style={{ fontSize: "24px" }} />
										<div style={{ fontSize: "20px", fontWeight: 700 }}>{this.isPreparingVideoProcessingQueue(pendingProcessing) ? "Preparing video edit" : "Processing video"}</div>
										<div style={{ maxWidth: "560px", lineHeight: 1.5, fontSize: "14px", opacity: 0.95 }}>
											{this.isPreparingVideoProcessingQueue(pendingProcessing)
												? "Preparing the edited video and adding it to the processing queue."
												: "The preview may still show the original upload until the converted playback file is ready."}
										</div>
										{pendingProcessingFeedback && pendingProcessingFeedback.progressHint &&
											<div style={{ maxWidth: "560px", lineHeight: 1.5, fontSize: "13px", color: "#fde68a" }}>
												{pendingProcessingFeedback.progressHint}
											</div>
										}
										{pendingProcessing.description &&
											<div style={{ maxWidth: "560px", lineHeight: 1.5, fontSize: "13px", opacity: 0.9 }}>
												{pendingProcessing.description}
											</div>
										}
										{this.renderVideoProcessingStatusMeta(pendingProcessing, {
											textColor: "#ffffff",
											chipBackground: "rgba(255, 255, 255, 0.14)",
											chipBorder: "rgba(255, 255, 255, 0.22)",
											showRefresh: true
										})}
										{pendingProcessing.masterPath &&
											<div style={{ maxWidth: "560px", lineHeight: 1.5, fontSize: "12px", opacity: 0.8 }}>
												Original source preserved as: {pendingProcessing.masterPath}
											</div>
										}
								</div>
							}
						</div>
					) : null;
					break;
				}
				case "audio":
				case "backgroundAudio":
				case "labelAudioFile":
				case "label1AudioFile":
				case "label2AudioFile":
				case "commentsAudioFile":
					{
						result = url ? <ReactAudioPlayer style={{ width: "100%", maxWidth: "400px" }} src={url} controls /> : null;
						break;
					}
				case "pdf": {
					if (url) {
						const _url = urlToSecureParameterObject(url);
						console.log("PDF fetch url", _url);
						// result = <iframe style={{width:"100%", height:"60.4vw"}} src={url} />;
						result = <div className="embed-responsive embed-responsive-210by297">
							<object className="embed-responsive-item" data={url} type="application/pdf" internalinstanceid="9" title="">
								<p>Your browser isn't supporting embedded pdf files. You can download the file
									<a href={url}> here</a>.</p>
							</object>
						</div>;
						// result = <Document
						// 	style={{width:"100%"}}	
						// 	file={_url}
						// 	onLoadSuccess={this.onDocumentLoad}
						// >
						// 	<Page pageNumber={1} scale={0.5} />
						// </Document>;
					}
					break;
				}
				case "threeD": {
					result = null;

					// result = url && validateUrl(url) ? <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
					// 	3D Preview will go here
					// </div> : null;
					break;
				}
				case "videoTextTrack": {
					result = null;

					// result = url && validateUrl(url) ? <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
					// 	Video Text Track Preview will go here
					// </div> : null;

					break;
				}
				default: {
					// result = url && validateUrl(url) ? <img alt="Preview" style={{ maxWidth: "800px" }} src={url} /> : null;

					let authorProperties = {};

					let cursor = state.select(state.select("selectedNodePath").get());
					let entity = cursor.get().entity;

					if (entity.authorProperties) {
						try {
							authorProperties = JSON.parse(entity.authorProperties);
						} catch (err) {
							authorProperties = {};
						}
					}

					// If have imageHotspots in authorProperties
					let imageHotspots = authorProperties.imageHotspots ? authorProperties.imageHotspots : null;

					let imagePreview = <ImageWithMarkup url={url} imageHotspots={imageHotspots} />;
					if (isDriveAssetPreview && this.state.showPreviewMetadataTitle && mediaMetadata.title) {
						imagePreview = (
							<div style={{ position: "relative", width: "fit-content", maxWidth: "100%" }}>
								{imagePreview}
								<div
									title={mediaMetadata.title}
									style={{
										position: "absolute",
										left: "10px",
										right: "10px",
										bottom: "10px",
										padding: "5px 10px",
										borderRadius: "8px",
										background: "rgba(7, 22, 43, 0.78)",
										color: "#ffffff",
										fontSize: "13px",
										fontWeight: 600,
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
										pointerEvents: "none"
									}}
								>
									{mediaMetadata.title}
								</div>
							</div>
						);
					}

					result = imagePreview;
				}
			}
		}
		if (_createUrlWrapper && result !== loadingDiv) {
			result = (
				<div>



					<FormGroup>
						<InputGroup>
							<FormControl onChange={(e) => { this.handleChangeUrl(e); }} type="text" value={url} ref={el => this[`ref-${type}`] = el} />
							<SplitButton
								componentClass={InputGroup.Button}
								id="input-dropdown-addon"
								title={<div onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon icon="clipboard" />&nbsp;Copy</div>}
								pullRight
							>
								<MenuItem key="1" onClick={() => { this.handlePaste(type); }}><FontAwesomeIcon icon="paste" />&nbsp;Paste Resource</MenuItem>
								<MenuItem divider />
								{generateTtsAudioMenuItem}
								{(this.props.markupImage || (!this.state.mobile && (this.props.urlParams.hasOwnProperty("markupImage") && this.props.urlParams.markupImage === "true"))) &&
									<>
										{this.isMediaMarkupV2Enabled() &&
											<MenuItem key="markupImageModalV2" onClick={() => {
												this.handleShowMarkupImageModal(MEDIA_MARKUP_MODAL_VERSION_V2);
											}}>
												<FontAwesomeIcon icon="pen" />&nbsp;Media Markup
											</MenuItem>
										}
										<MenuItem key="markupImageModalLegacy" onClick={() => {
											this.handleShowMarkupImageModal(MEDIA_MARKUP_MODAL_VERSION_LEGACY);
										}}>
											<FontAwesomeIcon icon="pen" />&nbsp;Media Markup (Legacy)
										</MenuItem>
										<MenuItem divider />
									</>
								}
								{!hideViewMediaAction &&
									<MenuItem key="1" onClick={() => { /*handleOpenInNewTab(url);*/ this.props.dispatch(showMediaPreviewModal, url, type); }}><FontAwesomeIcon icon="expand-wide" />&nbsp;View&nbsp;Media&nbsp;</MenuItem>
								}
							</SplitButton>
						</InputGroup>
					</FormGroup>
					{result}
					{/* <MediaQuery query='(max-width: 599px)'>
						<div style={{ marginTop: "5px" }}><a href="#clip" onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon name="clipboard" />&nbsp;Copy&nbsp;Media&nbsp;Address</a></div><div style={{ marginTop: "5px" }}><a href={url} target="_blank"><FontAwesomeIcon icon="external-link"/>&nbsp;View&nbsp;Media</a></div>
					</MediaQuery>
					<MediaQuery query='(min-width: 600px)'>
						<div style={{ marginTop: "5px" }}><a href="#clip" onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon name="clipboard" />&nbsp;Copy&nbsp;Media&nbsp;Address</a> | <a href={url} target="_blank"><FontAwesomeIcon icon="external-link" />&nbsp;View&nbsp;Media</a></div>
					</MediaQuery>	 */}
				</div>
			);
		} else if (driveReference && result !== loadingDiv) {
			result = (<div>
				<FormGroup>
					<InputGroup>
						<FormControl onChange={(e) => { this.handleChangeUrl(e); }} type="text" value={url} ref={el => this[`ref-${type}`] = el} />
						<SplitButton
							componentClass={InputGroup.Button}
							id="input-dropdown-addon"
							title={<div onClick={() => { copy(url); showSuccess("Copied", "Media address has been copied to clipboard"); }}><FontAwesomeIcon icon="clipboard" />&nbsp;Copy</div>}
							pullRight
						>
							<MenuItem key="1" onClick={() => { this.handlePaste(type); }}><FontAwesomeIcon icon="paste" />&nbsp;Paste</MenuItem>
							{generateTtsAudioMenuItem}
							<MenuItem divider />
							{!hideViewMediaAction &&
								<MenuItem key="2" onClick={() => { /*handleOpenInNewTab(url);*/ this.props.dispatch(showMediaPreviewModal, url, type); }}><FontAwesomeIcon icon="expand-wide" />&nbsp;View&nbsp;Media&nbsp;</MenuItem>
							}
						</SplitButton>
					</InputGroup>
				</FormGroup>
			</div>);
		} else if (result !== loadingDiv) {
			result = (
				<div style={{ display: "flex", flexDirection: "column" }}>
					{result}
					<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
						{this.isImageToolsEnabled() && type === "video" && this.props.videoThumbnailTargetPropName && this.canCreateVideoThumbnail() &&
							<Button
								style={{ marginTop: "5px" }}
								onClick={() => { this.handleShowVideoThumbnailModal(this.props.videoThumbnailTargetPropName); }}
							>
								<FontAwesomeIcon icon="camera" />&nbsp;Create Video Thumbnail
							</Button>
						}
						{this.isMediaToolsEnabled() && type === "video" && this.canEditCurrentVideo() &&
							<Button style={{ marginTop: "5px" }} onClick={this.handleShowVideoEditorModal}>
								<FontAwesomeIcon icon="edit" />&nbsp;Edit Video
							</Button>
						}
						{this.isMediaToolsEnabled() && type === "video" && this.canChunkCurrentVideo() &&
							<Button style={{ marginTop: "5px" }} onClick={this.handleShowVideoChunkModal}>
								<FontAwesomeIcon icon="cut" />&nbsp;Chunk Video
							</Button>
						}
						{(type === "image" && (this.props.markupImage || (!this.state.mobile && (this.props.urlParams.hasOwnProperty("markupImage") && this.props.urlParams.markupImage === "true")))) &&
							<>
								{this.isMediaMarkupV2Enabled() &&
									<Button style={{ marginTop: "5px", marginRight: "10px" }} onClick={() => { this.handleShowMarkupImageModal(MEDIA_MARKUP_MODAL_VERSION_V2); }}><FontAwesomeIcon icon="pen" />&nbsp;Media&nbsp;Markup</Button>
								}
								<Button style={{ marginTop: "5px", marginRight: "10px" }} onClick={() => { this.handleShowMarkupImageModal(MEDIA_MARKUP_MODAL_VERSION_LEGACY); }}><FontAwesomeIcon icon="pen" />&nbsp;Media&nbsp;Markup&nbsp;(Legacy)</Button>
							</>
						}
						{!hideViewMediaAction && !this.state.mobile && <Button style={{ marginTop: "5px", maxWidth: "200px" }} onClick={() => { /*handleOpenInNewTab(url)*/ this.props.dispatch(showMediaPreviewModal, url, type); }}><FontAwesomeIcon icon="expand-wide" />&nbsp;View&nbsp;Media&nbsp;</Button>}
						{this.isImageToolsEnabled() && type === "image" && this.canEditCurrentImage() &&
							<Button style={{ marginTop: "5px" }} onClick={() => this.handleShowImageEditorModal(this.props.propName)}>
								<FontAwesomeIcon icon="edit" />&nbsp;Edit Image
							</Button>
						}
						{isDriveAssetPreview && this.isAiAssistantUiEnabled() &&
							<Button style={{ marginTop: "5px" }} onClick={() => this.handleUseInAiAssistant(selectedDriveResource)}>
								<FontAwesomeIcon icon="comment-alt" />&nbsp;Use in AI Assistant
							</Button>
						}
						{isDriveAssetPreview &&
							<Button style={{ marginTop: "5px" }} onClick={() => this.handleShowMetadataEditor(selectedDriveResource)}>
								<FontAwesomeIcon icon="edit" />&nbsp;Metadata
							</Button>
						}
						{isDriveAssetPreview &&
							<Button style={{ marginTop: "5px" }} onClick={this.handleToggleMediaMetadataPanel}>
								<FontAwesomeIcon icon="tags" />&nbsp;{this.state.showMediaMetadataPanel ? "Hide Metadata" : "Show Metadata"}
							</Button>
						}
					</div>
					{isDriveAssetPreview && this.state.showMediaMetadataPanel &&
						<div style={{ marginTop: "8px", padding: "10px", border: "1px solid #d8e1ee", borderRadius: "6px", backgroundColor: "#f8fbff" }}>
							<div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "8px" }}>
								<Button
									bsStyle={this.state.showPreviewMetadataTitle ? "primary" : "default"}
									bsSize="small"
									onClick={() => this.handleTogglePreviewMetadataField("title")}
								>
									{this.state.showPreviewMetadataTitle ? "Hide Title" : "Show Title"}
								</Button>
								<Button
									bsStyle={this.state.showPreviewMetadataDescription ? "primary" : "default"}
									bsSize="small"
									onClick={() => this.handleTogglePreviewMetadataField("description")}
								>
									{this.state.showPreviewMetadataDescription ? "Hide Description" : "Show Description"}
								</Button>
								<Button
									bsStyle={this.state.showPreviewMetadataTags ? "primary" : "default"}
									bsSize="small"
									onClick={() => this.handleTogglePreviewMetadataField("tags")}
								>
									{this.state.showPreviewMetadataTags ? "Hide Tags" : "Show Tags"}
								</Button>
							</div>
							{!hasMetadata &&
								<div style={{ color: "#6b7f95" }}>
									No metadata found for this file yet. Use metadata generate actions to create and save title, description, transcript, or tags.
								</div>
							}
							{this.state.showPreviewMetadataTitle && mediaMetadata.title &&
								<div style={{ marginBottom: "6px" }}>
									<b>Title:</b> {mediaMetadata.title}
								</div>
							}
							{this.state.showPreviewMetadataDescription && mediaMetadata.description &&
								<div style={{ marginBottom: "6px" }}>
									<b>Description:</b> {mediaMetadata.description}
								</div>
							}
							{this.state.showPreviewMetadataTags && mediaMetadata.tags.length > 0 &&
								<div style={{ display: "flex", alignItems: "flex-start", gap: "6px", flexWrap: "wrap" }}>
									<b style={{ marginTop: "4px" }}>Tags:</b>
									{mediaMetadata.tags.map((tag) => (
										<span
											key={`preview-metadata-tag-${selectedDriveResource?.guid || "resource"}-${tag}`}
											style={{
												backgroundColor: "#f1f3f4",
												color: "#333",
												padding: "4px 8px",
												borderRadius: "12px",
												fontSize: "12px",
												whiteSpace: "nowrap"
											}}
										>
											{tag}
										</span>
									))}
								</div>
							}
						</div>
					}
				</div>);
		}
		return result;
	}

	render() {

		const { value, propName, accept, label, entityId } = this.props;

		let authorProperties = {};

		let cursor = state.select(state.select("selectedNodePath").get());
		let entity = cursor.get().entity;

		if (entity.authorProperties) {
			try {
				authorProperties = JSON.parse(entity.authorProperties);
			} catch (err) {
				authorProperties = {};
			}
		}

		// If have imageHotspots in authorProperties
		let imageHotspots = authorProperties.imageHotspots ? authorProperties.imageHotspots : null;
		let imageKenBurnsEffect = authorProperties.imageKenBurnsEffect ? authorProperties.imageKenBurnsEffect : null;
		let imageKenBurnsEffectVariants = authorProperties.imageKenBurnsEffectVariants ? authorProperties.imageKenBurnsEffectVariants : null;
		const markupPreviewAudioUrl = this.getMarkupPreviewAudioUrl(entity);
		const previousCameraStartContext = this.getPreviousCameraStartContext();

		const driveReference = isDriveReference(value);
		let _accept = accept;
		if (!_accept) {
			_accept = "*/*";
		}
		let previewUrl = null;
		let externalResource = null;
		if (driveReference) {
			try {
				externalResource = this.getDriveResourceFromValue(value);
				previewUrl = externalResource ? getUrlForResource(externalResource, externalResource) : null;
				if (propName === "video" && externalResource) {
					previewUrl = this.getResolvedVideoPreviewUrl(previewUrl, externalResource);
				}
				// if (previewUrl.includes(".vtt")) {
				// 	getContent(resourceEntry.guid).then(content => {
				// 		console.log("!@!@!@ CONTENT", content);
				// 	}).catch(err => {
				// 		showError("Get Content", "An error occurred while attempting to get content: " + err);
				// 	});
				// }
			} catch (err) {
				console.warn(err);
			}
		} else {
			previewUrl = value;
			externalResource = value;
		}

			console.log("Render a preview", previewUrl);
			const previewType = this.props.previewType || this.props.mediaType || propName;
			const preview = this.renderMediaPanel(previewType, previewUrl, !driveReference, externalResource);
		const currentProcessingUpload = this.getCurrentProcessingUpload();
		const currentProcessingFeedback = this.getVideoProcessingFeedback(currentProcessingUpload);
		const currentProcessingPreparing = this.isPreparingVideoProcessingQueue(currentProcessingUpload);
			const imageToolsEnabled = this.isImageToolsEnabled();
			const mediaToolsEnabled = this.isMediaToolsEnabled();
			console.log("EXTERNAL RESOURCE", externalResource);

		const videoThumbnailSource = this.getAssociatedVideoThumbnailSource();
		const component = (driveReference) ? <InlineFilePicker handleReplaceValue={this.handleReplaceValue} handleQuickUpload={this.handleQuickUpload} handleReplaceExisting={this.handleReplaceExisting} actionBarTop edit onFileSelected={this.handleSelectFile} value={externalResource} reference={value} accept={accept} entityId={entityId} handleShowPasteImageModal={this.handleShowPasteImageModal} handleShowAiImageGeneratorModal={this.handleShowAiImageGeneratorModal} handleShowMarkupImageModal={this.handleShowMarkupImageModal} mediaMarkupV2Enabled={this.isMediaMarkupV2Enabled()} handleShowVideoThumbnailModal={this.handleShowVideoThumbnailModal} showCreateVideoThumbnail={imageToolsEnabled && this.props.propName === "image" && !!videoThumbnailSource} hideVideoAdvancedToggle={propName === "video"} /> : null;

		let generateTtsAudioMenuItem;
		console.log("MEDIA INJECTOR", this.props);
		if (this.props.generateTtsAudio) {
			generateTtsAudioMenuItem = <>
				<MenuItem eventKey="3" disabled={!driveReference} onClick={() => { this.handleShowGenerateTtsAudioForPropertyModal(propName); }}><div><FontAwesomeIcon icon="volume-up" /> Generate TTS Audio</div><div><small>Generate audio from associated text.</small></div></MenuItem>
				<MenuItem divider />
			</>;
		}

		let pasteImageModal;

		if (this.state.showPasteImageModal) {
			pasteImageModal = <PasteImageModal open={this.state.showPasteImageModal} onPaste={this.pasteFunction} onClose={this.handleClosePasteImageModal} nodePath={getSelectedNodePath()} />;
		}

		let aiImageGeneratorModal;

		if (this.state.showAiImageGeneratorModal) {
			aiImageGeneratorModal = <AiImageGeneratorModal open={this.state.showAiImageGeneratorModal} onClose={this.handleCloseAiImageGeneratorModal} />;
		}

		let markupImageModal;
		if (this.state.showMarkupImageModal) {
			if (this.state.markupImageModalVersion !== MEDIA_MARKUP_MODAL_VERSION_LEGACY && this.isMediaMarkupV2Enabled()) {
				markupImageModal = (
					<MarkupImageModalV2
						open={this.state.showMarkupImageModal}
						onClose={this.handleCloseMarkupImageModal}
						onSaveActivity={this.handleSaveMediaMarkupActivity}
						urlParams={this.props.urlParams}
						url={previewUrl}
						audioUrl={markupPreviewAudioUrl}
						imageHotspots={imageHotspots}
						imageKenBurnsEffect={imageKenBurnsEffect}
						imageKenBurnsEffectVariants={imageKenBurnsEffectVariants}
						imageResizeMode={this.getEffectiveImageResizeMode()}
						previousCameraStartContext={previousCameraStartContext}
					/>
				);
			} else {
				markupImageModal = (
					<MarkupImageModal
						open={this.state.showMarkupImageModal}
						onClose={this.handleCloseMarkupImageModal}
						url={previewUrl}
						audioUrl={markupPreviewAudioUrl}
						imageHotspots={imageHotspots}
						imageKenBurnsEffect={imageKenBurnsEffect}
					/>
				);
			}
		}

		let imageEditorModal;
		const imageEditorSource = this.getCurrentImageEditorSource();
		if (imageToolsEnabled && this.state.showImageEditorModal && imageEditorSource) {
			imageEditorModal = (
				<ImageEditorModal
					open={this.state.showImageEditorModal}
					onClose={this.handleCloseImageEditorModal}
					onCreate={this.handleCreateEditedImage}
					imageUrl={imageEditorSource.url}
					driveObjectGuid={imageEditorSource.driveObjectGuid}
					imageLabel={imageEditorSource.label}
					defaultBaseName={imageEditorSource.defaultBaseName}
					originalImageName={imageEditorSource.originalImageName}
					overwriteTargetPath={imageEditorSource.overwriteTargetPath}
					urlParams={this.props.urlParams}
				/>
			);
		}

			let videoThumbnailModal;
			if (imageToolsEnabled && this.state.showVideoThumbnailModal && videoThumbnailSource) {
				videoThumbnailModal = (
				<VideoThumbnailModal
					open={this.state.showVideoThumbnailModal}
					onClose={this.handleCloseVideoThumbnailModal}
					onCreate={this.handleCreateVideoThumbnail}
					videoUrl={videoThumbnailSource.url}
					driveObjectGuid={videoThumbnailSource.driveObjectGuid}
					serverFrameSource={videoThumbnailSource.drivePath ? {
						bucket: _.get(env, "s3.assetsBucket", ""),
						key: videoThumbnailSource.drivePath
					} : null}
					videoFileName={videoThumbnailSource.videoFileName}
					videoLabel={videoThumbnailSource.label}
					defaultBaseName={videoThumbnailSource.defaultBaseName}
					/>
				);
			}

			let videoEditorModal;
			if (mediaToolsEnabled && this.state.showVideoEditorModal && videoThumbnailSource) {
				const serverPreviewSource = videoThumbnailSource.drivePath ? {
					bucket: _.get(env, "s3.assetsBucket", ""),
					key: videoThumbnailSource.drivePath,
					frameSeconds: 0,
					revision: Number(_.get(videoThumbnailSource, "resource.revision")) || 0
				} : null;
				const videoFileName = videoThumbnailSource.videoFileName || videoThumbnailSource.label || "video.mp4";
				videoEditorModal = (
					<VideoProcessingOptionsModal
						open={this.state.showVideoEditorModal}
						onClose={this.handleCloseVideoEditorModal}
						onContinue={this.handleCreateEditedVideo}
						initialOptions={getStoredVideoProcessingOptions()}
						fileName={videoFileName}
						previewUrl={videoThumbnailSource.url}
						serverPreviewSource={serverPreviewSource}
						videoCount={1}
						allowFileRename
						defaultOutputFileName={buildEditedVideoOutputFileName(videoFileName)}
						allowOverwriteOption={!!videoThumbnailSource.drivePath}
						overwriteTargetPath={videoThumbnailSource.drivePath || ""}
						orientationSummary={getDefaultVideoOrientationSummary(1)}
						showThumbnailAutoLinkOption={!!this.props.videoThumbnailTargetPropName}
						thumbnailAutoLinkLabel={`Auto-link thumbnail to ${this.props.videoThumbnailTargetPropName || "image"}`}
						showEditVideoButton={false}
						deferInitialServerPreview
						closeOnContinue
						title="Edit Video"
						description={<span>Adjust processing options for <b>{videoFileName}</b>, then save a new Drive video or overwrite the current one.</span>}
						continueLabel="Save Video"
					/>
				);
			}

			let videoChunkModal;
			const videoChunkSource = this.getCurrentVideoChunkSource();
			if (this.canChunkCurrentVideo() && this.state.showVideoChunkModal && videoChunkSource) {
				videoChunkModal = (
					<VideoChunkModal
						open={this.state.showVideoChunkModal}
						onClose={this.handleCloseVideoChunkModal}
						onCreate={this.handleCreateVideoChunks}
						previewUrl={videoChunkSource.previewUrl}
						fileName={videoChunkSource.fileName}
						chunkSource={videoChunkSource.chunkSource}
						playbackChunkSource={videoChunkSource.playbackChunkSource}
						masterChunkSource={videoChunkSource.masterChunkSource}
						baseOutputPath={videoChunkSource.baseOutputPath}
						sourcePlaybackGuid={videoChunkSource.sourcePlaybackGuid}
						sourcePlaybackPath={videoChunkSource.sourcePlaybackPath}
						baseProcessingOptions={videoChunkSource.baseProcessingOptions}
						playbackBaseProcessingOptions={videoChunkSource.playbackBaseProcessingOptions}
						masterBaseProcessingOptions={videoChunkSource.masterBaseProcessingOptions}
						sourceMetaData={videoChunkSource.sourceMetaData}
						orgId={getOrgId()}
						allowAutoCreateOutline={this.canAutoCreateChunkOutline()}
						allowOutlineSections={this.canAutoCreateChunkOutlineSections()}
						defaultAutoCreateOutline
						defaultOutlineLabelBase={this.getChunkOutlineLabelBase()}
						defaultUseMasterSource={videoChunkSource.defaultUseMasterSource}
						sourceDescription={videoChunkSource.sourceDescription}
						playbackSourceDescription={videoChunkSource.playbackSourceDescription}
						masterSourceDescription={videoChunkSource.masterSourceDescription}
						savedDraft={this.getCurrentVideoChunkDraft()}
						onSaveDraft={this.handleSaveVideoChunkDraft}
					/>
				);
			}

			let videoProcessingOptionsModal;
			if (this.state.showVideoProcessingOptionsModal) {
				const pendingVideoUpload = this.state.pendingVideoUpload || {};
					videoProcessingOptionsModal = (
						<VideoProcessingOptionsModal
							open={this.state.showVideoProcessingOptionsModal}
							onClose={this.handleCloseVideoProcessingOptionsModal}
							onContinue={this.handleContinueVideoProcessingOptionsModal}
							initialOptions={getStoredVideoProcessingOptions()}
							fileName={_.get(pendingVideoUpload, "files[0].name", "")}
							previewFile={_.get(pendingVideoUpload, "files[0]", null)}
							videoCount={_.get(pendingVideoUpload, "files.length", 1) || 1}
							allowFileRename={(_.get(pendingVideoUpload, "files.length", 0) || 0) === 1}
							orientationSummary={_.get(pendingVideoUpload, "orientationSummary", null)}
							showThumbnailAutoLinkOption={!!this.props.videoThumbnailTargetPropName}
							thumbnailAutoLinkLabel={`Auto-link thumbnail to ${this.props.videoThumbnailTargetPropName || "image"}`}
						/>
					);
			}

		let metadataEditorModal;
		if (this.state.showMetadataEditorModal) {
			metadataEditorModal = (
				<DriveMetadataEditorModal
					open={this.state.showMetadataEditorModal}
					onClose={this.handleHideMetadataEditor}
					targetName={this.state.metadataEditorTarget?.name || "selected file"}
					previewUrl={previewUrl}
					previewType={this.getMetadataResourceMediaType(this.state.metadataEditorTarget || externalResource)}
					galleryItems={this.getMetadataEditorGalleryItems()}
					galleryIndex={this.getMetadataEditorGalleryIndex()}
					saving={this.state.metadataEditorSaving}
					metadataGeneratingField={this.state.metadataGeneratingField}
					title={this.state.metadataEditorTitle}
					description={this.state.metadataEditorDescription}
					transcript={this.state.metadataEditorTranscript}
					transcriptVtt={this.state.metadataEditorTranscriptVtt}
					primaryTags={this.state.metadataEditorPrimaryTags}
					secondaryTags={this.state.metadataEditorSecondaryTags}
					tagsInput={this.state.metadataEditorTagsInput}
					transcriptProvider={this.state.metadataTranscriptProvider}
					tagsProvider={this.state.metadataTagsProvider}
					onTitleChange={this.handleMetadataEditorTitleChange}
					onDescriptionChange={this.handleMetadataEditorDescriptionChange}
					onTranscriptChange={this.handleMetadataEditorTranscriptChange}
					onTranscriptVttChange={this.handleMetadataEditorTranscriptVttChange}
					onTagsInputChange={this.handleMetadataEditorTagsInputChange}
					onAddTags={this.handleAddMetadataEditorInputTags}
					onRemovePrimaryTag={this.handleRemoveMetadataEditorPrimaryTag}
					onPromoteSecondaryTag={this.handlePromoteMetadataEditorSecondaryTag}
					onPromoteAllSecondaryTags={this.handlePromoteAllMetadataEditorSecondaryTags}
					onGallerySelect={this.handleMetadataEditorGallerySelect}
					onTranscriptProviderChange={this.handleMetadataTranscriptProviderChange}
					onTagsProviderChange={this.handleMetadataTagsProviderChange}
					onGenerateTitle={this.handleGenerateMetadataTitle}
					onGenerateDescription={this.handleGenerateMetadataDescription}
					onGenerateTranscript={this.handleGenerateMetadataTranscript}
					onGenerateTranscriptVtt={this.handleGenerateMetadataTranscriptVtt}
					onGenerateTags={this.handleGenerateMetadataTags}
					onSaveAndPrevious={() => this.handleSaveMetadataEditorAndNavigate(-1)}
					onSaveAndNext={() => this.handleSaveMetadataEditorAndNavigate(1)}
					onSave={this.handleSaveMetadataEditor}
				/>
			);
		}

		return (
			<AmbifiLoader show={this.state.uploading}>
				<div>
					<div>
						<label>{label}</label>
						{/* <Connected>
								<br/><span style={{ color: "red", fontWeight: "bold" }}><FontAwesomeIcon icon="exclamation-triangle " /> No Connection, upload may fail, make sure to  </span>
							</Connected> */}
					</div>
						<div style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", borderBottom: "1px dashed gray", paddingBottom: "10px" }}>
							<input ref={this.fileUploadField} type="file" id={`quick-upload-inline-${entityId}`} onChange={this.handleQuickUploadSubmit} style={{ display: "none" }} />
							<DropdownButton
							id={`${entityId}-reference-type-selector`}
							title={
								driveReference ? (
									<span><FontAwesomeIcon icon={["far", "hdd"]} /> From AmbiFi Drive</span>
								) : (
									<span><FontAwesomeIcon icon="external-link" /> From External (Self Hosted)</span>
								)
							}
						>
							<MenuItem eventKey="1" disabled={driveReference} onClick={() => { this.handleSwitchMode("drive"); }}><div><FontAwesomeIcon icon={["far", "hdd"]} /> Drive</div><div><small>Upload and reference files from your AmbiFi Drive.</small></div></MenuItem>
							<MenuItem eventKey="2" disabled={!driveReference} onClick={() => { this.handleSwitchMode("url"); }}><div><FontAwesomeIcon icon="external-link" /> External (Self Hosted)</div><div><small>Provide a URL to external files.</small></div></MenuItem>
							{generateTtsAudioMenuItem}
							</DropdownButton>
							<Button bsStyle="danger" onClick={this.handleDeleteMediaProperty}><FontAwesomeIcon icon="times" /></Button>
						</div>
						{propName === "video" && this.isMediaToolsEnabled() &&
							<div style={{ marginBottom: "12px" }}>
								<VideoProcessingAdvancedToggle enabled={this.state.showAdvancedVideoOptions} onChange={this.handleToggleVideoAdvancedOptions} />
							</div>
						}
						<div style={{ display: "flex", flexDirection: "column" }}>
						{propName === "video" && currentProcessingUpload &&
							<div
								style={{
									marginBottom: "12px",
									padding: "12px 14px",
									borderRadius: "8px",
									background: "#eef6ff",
									border: "1px solid #cfe3fb",
									color: "#1f4f82"
								}}
							>
								<div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start", flexWrap: "wrap", marginBottom: "4px" }}>
									<div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 700 }}>
										<FontAwesomeIcon icon="spinner" spin />
										<span>{currentProcessingPreparing ? "Preparing video edit" : "Processing video"}</span>
									</div>
									{currentProcessingFeedback && currentProcessingFeedback.elapsedLabel &&
										<div style={{ fontSize: "12px", lineHeight: 1.5, opacity: 0.9 }}>
											Elapsed {currentProcessingFeedback.elapsedLabel}
										</div>
									}
								</div>
								<div style={{ fontSize: "13px", lineHeight: 1.5 }}>
									{currentProcessingPreparing
										? "Preparing the edited video and adding it to the processing queue."
										: "The uploaded source is still being converted. This preview may continue to show the original upload until processing finishes."}
								</div>
								{currentProcessingFeedback && currentProcessingFeedback.progressHint &&
									<div style={{ fontSize: "12px", lineHeight: 1.5, marginTop: "6px", color: "#7c4a03" }}>
										{currentProcessingFeedback.progressHint}
									</div>
								}
								{currentProcessingUpload.description &&
									<div style={{ fontSize: "12px", lineHeight: 1.5, marginTop: "6px", opacity: 0.9 }}>
										{currentProcessingUpload.description}
									</div>
								}
								{this.renderVideoProcessingStatusMeta(currentProcessingUpload, {
									showRefresh: true
								})}
							</div>
						}
						{component}
						{preview}
						<hr />
					</div>
					{pasteImageModal}
					{aiImageGeneratorModal}
					{markupImageModal}
						{imageEditorModal}
						{videoThumbnailModal}
						{videoEditorModal}
						{videoChunkModal}
						{videoProcessingOptionsModal}
						{metadataEditorModal}
					</div>
				</AmbifiLoader>
		);
	}

}


export default branch((props) => {
	return {
		guidToResource: ["drive", "guidToResource"],
		uploadStatus: ["uploads", props.entityId],
		urlParams: ["appState", "urlParams"],
		selectedOrg: ["selectedOrg"],
		markupImage: ["appCapabilities", "markupImage"]
	};
}, MediaPropertyInjector);
